/* eslint-disable radix */
import {
  DownloadOutlined,
  EnvironmentOutlined,
  FileExcelOutlined
} from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import {
  Alert,
  Button,
  Card,
  Checkbox,
  Col,
  Collapse,
  Divider,
  Form,
  Grid,
  Input,
  Modal,
  Radio,
  Result,
  Row,
  Select,
  Slider,
  Space,
  Spin,
  Switch,
  Upload,
  message
} from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { debounce, isEqual, omit } from 'lodash';
import lodashClonedeep from 'lodash/cloneDeep';
import React, {
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState
} from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import {
  PlanCoberturaItemMinMaxConfig,
  PlanConfig
} from '../../admin/aseguradora/AdminAseguradoraModals';
import PlanEditor from '../../admin/aseguradora/PlanEditor';
import {
  aniosFetcher,
  departamentosFetcher,
  distritosFetcher,
  marcasFetcher,
  modelosFetcher,
  submodelosFetcher
} from '../../api/queries';
import { Label, SubSubtitleStart, Subtitle, Title } from '../../components';
import ContactForm from '../../components/ContactForm';
import LogoYTexto from '../../components/LogoYTexto';
import MapView from '../../components/MapView';
import MonedaSelector from '../../components/MonedaSelector';
import NotFoundContentLoading from '../../components/NotFoundContentLoading';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import StepperSolicitud from '../../components/StepperSolicitud';
import VigenciaForm from '../../components/VigenciaForm';
import {
  CONFIG,
  TIPOS_COMBUSTIBLE,
  TIPOS_USO_VEHICULO,
  TIPOS_USO_VEHICULO_OTROS
} from '../../constants';
import EmpresaContext from '../../context/empresa-context';
import SessionContext from '../../context/session-context';
import { SolicitudProvider } from '../../context/solicitud-context';
import UserContext from '../../context/user-context';
import WhatsAppContext from '../../context/whatsapp-context';
import GroupPlanSelectorMultiple from '../../forms/personal/GroupPlanSelectorMultiple';
import PlanSelector from '../../forms/personal/PlanSelector';
import { controlMinMax } from '../../functions/controlMinMax';
import {
  errorHandler,
  exportCSVFile,
  filtrarListado,
  formatCelular,
  getCoordenadasByDireccion,
  getTipoValidacion,
  reconocerCombustible
} from '../../utils';
import { instanceRef } from '../../utils/axios';
import formatoGs from '../../utils/converters';
import DescuentoRecargoInput from './DescuentoRecargoInput';

const { useBreakpoint } = Grid;
const { Option } = Select;
const { Panel } = Collapse;

const maxWidth = 1096;

const steps = [
  {
    title: 'Paso 1',
    description: (
      <span>
        <strong>Parámetros de la cotización</strong>
      </span>
    )
  },
  {
    title: 'Paso 2',
    description: (
      <span>
        <strong>Edición de planes</strong>
      </span>
    )
  },
  {
    title: 'Paso 3',
    description: (
      <span>
        <strong>Confirmación de datos</strong>
      </span>
    )
  }
];
function PanelHeader(props) {
  const { comision } = props;
  return (
    <Row justify="start" align="middle">
      <Col
        style={{
          textAlign: 'start',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          width: '100%',
          paddingLeft: 20,
          paddingRight: 20
        }}
      >
        Rango Comisión - {comision.valor}%
      </Col>
    </Row>
  );
}
const scrollToRef = (ref) => {
  if (ref && ref.current) {
    const headerOffset = 64;
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = ref.current.getBoundingClientRect().top;
    const elementPosition = elementRect - bodyRect;
    const offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
};

const scrollToField = (element, top) => {
  if (element) {
    const headerOffset = 64;
    const reajuste = 40;
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = element.getBoundingClientRect().top;
    const elementPosition = elementRect - bodyRect;
    const offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition + top - reajuste,
      behavior: 'smooth'
    });
  }
};

const defaultVigencia = {
  aseguradora: null,
  config: null,
  vigencia: {
    desde: null,
    hasta: null,
    cantidad_dias: null
  },
  pagos: {
    cantidad_pagos: null,
    frecuencia: null
  }
};

const UploadCotizacionMasivaForm = ({
  onFinish,
  solicitado,
  onClick,
  loading,
  amedida,
  goBack,
  setCotizacionMasivaPersonaList,
  setLoading,
  setEnvioSms,
  setEnvioCorreo,
  setTextoSms,
  textoSms,
  envioSms,
  envioCorreo,
  setTextoBodyMail,
  textoBodyMail,
  asuntoMail,
  setAsuntoMail,
  campañaName,
  setCampañaName,
  empresaTieneSms,
  ...props
}) => {
  const [form] = Form.useForm();
  const [, setData] = useState([]);
  const [uploadLoading] = useState(false);
  const maxTextMessage = 1000;
  const formatosArchivo =
    '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';

  const handleInputChange = (event) => {
    const inputText = event.target.value;
    // if (!SMS_CHARACTERS_PROHIBIDO.test(inputText)) {
    setTextoSms(inputText);
    // }
  };
  const handleMailBodyChange = (event) => {
    const inputText = event.target.value;
    setTextoBodyMail(inputText);
  };
  const handleAsuntoMailChange = (event) => {
    const inputText = event.target.value;
    setAsuntoMail(inputText);
  };
  const handleCampañaChange = (event) => {
    const inputText = event.target.value;
    setCampañaName(inputText);
  };

  const handleSmsLength = () => {
    if (textoSms.length > maxTextMessage) {
      setTextoSms(textoSms.slice(0, maxTextMessage));
    }
  };

  const descargarFormato = () => {
    // call the exportCSVFile() function to process the JSON and trigger the download
    const encabezado = {
      id: 'ID',
      nombres: 'NOMBRES',
      celular: 'CELULAR',
      correo: 'CORREO'
    };
    exportCSVFile(encabezado, [], 'Cotizacion Masiva');
  };

  /* const columns = [
    {
      title: 'Nro',
      dataIndex: ['id'],
      key: ['id'],
      align: 'right'
    },
    {
      title: 'Nombres',
      dataIndex: ['nombres'],
      key: ['nombres'],
      align: 'left'
    },

    {
      title: 'Celular',
      dataIndex: ['celular'],
      key: ['celular'],
      align: 'left'
    },
    {
      title: 'Correo',
      dataIndex: ['correo'],
      key: ['correo'],
      align: 'left'
    }
  ]; */

  function beforeUpload(file) {
    const isPermittedFormat =
      file.type === '.csv' ||
      file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      file.type === 'application/vnd.ms-excel';

    if (!isPermittedFormat) {
      message.error('El formato del archivo no está permitido.');
      return false || Upload.LIST_IGNORE;
    }
    return isPermittedFormat;
  }

  const uploadFile = async (file, onSuccess, onError) => {
    try {
      const formData = new FormData();
      formData.append('file', file.file);
      const response = await instanceRef.instance.post(
        `archivos/cotizacionmasiva`,
        formData
      );
      form.setFieldsValue({ cotizacion_masiva_persona: response.data.data });
      form.setFieldsValue({ archivo: response.data.data });
      setData(response.data.data);

      setCotizacionMasivaPersonaList(response.data.data);
      onSuccess();
    } catch (error) {
      if (error?.response?.data?.message) {
        Modal.error({
          maskClosable: true,
          closable: true,
          width: 1000,
          title: error?.response?.data?.message.mensaje,
          content: (
            <>
              {error?.response?.data.message.errorList.length > 0 && (
                <>
                  {error?.response?.data.message.errorList.map(
                    (item, index) => (
                      <Fragment key={index}>
                        <span>
                          ID: {item.id}, Error: {item.error}
                        </span>
                        <br />
                      </Fragment>
                    )
                  )}
                </>
              )}
            </>
          )
        });
        onError();
      } else {
        message.error('Verificar el formato del archivo');
        onError();
      }
    }
  };

  return (
    <Form
      name="uploadCotizacionMasivaForm"
      form={form}
      layout="vertical"
      onFinish={onFinish}
      {...props}
    >
      <Card
        style={{ padding: 0 }}
        cover={
          <div
            style={{
              fontSize: 22,
              fontWeight: 'bold',
              background: CONFIG.COLOR_PRIMARY,
              color: 'white',
              padding: 8,
              borderRadius: '2px 2px 0 0'
            }}
          >
            Para enviar la cotización a los clientes, completá los siguientes
            datos
          </div>
        }
      >
        <Form.Item
          label="Subir archivo Excel"
          name="archivo"
          rules={[{ required: true }]}
        >
          <Row gutter={[8, 8]} style={{ textAlign: 'start' }}>
            <Col xs={12} md={12}>
              <Upload
                style={{ width: 'auto !important' }}
                name="listado"
                accept={formatosArchivo}
                customRequest={(file) =>
                  uploadFile(file, file.onSuccess, file.onError)
                }
                beforeUpload={(file) => beforeUpload(file)}
                maxCount={1}
              >
                <Button
                  type="primary"
                  ghost
                  icon={<FileExcelOutlined />}
                  disabled={uploadLoading}
                >
                  Cargar lista
                </Button>
              </Upload>
            </Col>

            <Col
              xs={12}
              md={12}
              style={{ display: 'flex', justifyContent: 'end' }}
            >
              <Button
                type="primary"
                ghost
                icon={<DownloadOutlined />}
                disabled={uploadLoading}
                onClick={descargarFormato}
              >
                Descargar formato
              </Button>
            </Col>
          </Row>

          <br />
          <br />
          <div
            style={{
              ...{
                width: '100%',
                marginTop: '0px',
                marginBottom: 16,
                textAlign: 'left',
                border: 'none'
              }
              // ...style
            }}
          >
            {/* !mostrarList ? (
                  <div
                    style={{
                      // margin: 'auto',
                      width: 'fit-content'
                    }}
                  >
                    <TextWithEditButton
                      descripcion="Ver listado de personas"
                      loading={loading}
                      tituloEditTooltip="Ver"
                      onClick={() => setMostrarList(true)}
                      icon={<EyeOutlined />}
                    />
                  </div>
                ) : (
                  <>
                    <Card
                      size="small"
                      title="Listado de Personas"
                      style={{
                        border: `${CONFIG.COLOR_PRIMARY} 1px solid`,
                        textAlign: 'left',
                        maxWidth: 1000,
                        margin: 'auto'
                        // ...(center ? { margin: 'auto' } : {})
                      }}
                      extra={
                        <Button
                          size="small"
                          type="link"
                          onClick={() => setMostrarList(false)}
                        >
                          Minimizar
                        </Button>
                      }
                    >
                      <Table
                        scroll
                        style={{ width: '100%' }}
                        bordered
                        dataSource={[...data]}
                        columns={columns}
                        pagination={false}
                        rowKey={(record) => record.id}
                        size="small"
                      />
                    </Card>
                  </>
                    ) */}
          </div>
        </Form.Item>

        <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
          <Col xs={24} md={12}>
            <Form.Item
              label="Nombre de la campaña"
              name="campaña"
              rules={[{ required: true }]}
            >
              <Input
                onChange={(e) => {
                  handleCampañaChange(e);
                }}
              />
            </Form.Item>
            <Form.Item
              label="Enviar por: "
              rules={[{ required: true }]}
              name="medio_envio"
            >
              <Checkbox
                onChange={(e) => {
                  setEnvioSms(e.target.checked);
                  if (e.target.checked) {
                    form.setFieldsValue({ medio_envio: e.target.checked });
                  } else {
                    form.setFieldsValue({ medio_envio: undefined });
                  }
                }}
              >
                SMS
              </Checkbox>
              <Checkbox
                onChange={(e) => {
                  setEnvioCorreo(e.target.checked);
                  if (e.target.checked) {
                    form.setFieldsValue({ medio_envio: e.target.checked });
                  } else {
                    form.setFieldsValue({ medio_envio: undefined });
                  }
                }}
              >
                Correo electrónico
              </Checkbox>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
          {envioSms && (
            <Col xs={24} md={12}>
              <Form.Item
                label="Mensaje de texto para sms"
                name="sms_texto"
                rules={[
                  { required: envioSms },
                  {
                    max: 160,
                    message: 'Alcanzaste la longitud máxima permitida'
                  }
                ]}
                validateFirst
              >
                <TextArea
                  value={textoSms}
                  // maxLength={3}
                  rows={4}
                  onChange={(e) => {
                    handleInputChange(e);
                    handleSmsLength();
                  }}
                  // onKeyPress={(e) => !SMS_CHARACTERS_PROHIBIDO.test(e.key)}
                  onPaste={(e) => {
                    const clipboardText = e.clipboardData.getData('text/plain');
                    const specialCharRegex = new RegExp(
                      // eslint-disable-next-line no-useless-escape
                      /^[À-ÿ¡¿?¡!.,;:()&$@#\-_+=\/\s]*$/
                    );

                    if (specialCharRegex.test(clipboardText)) {
                      e.preventDefault();
                      return false;
                    }
                    return true;
                  }}
                  onBlur={() => handleSmsLength()}
                />
              </Form.Item>
            </Col>
          )}
        </Row>
        <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
          {envioCorreo && (
            <>
              <Col xs={24} md={12}>
                <Form.Item
                  label="Asunto del correo"
                  name="correo_asunto"
                  rules={[{ required: envioCorreo }]}
                >
                  <Input
                    onChange={(e) => {
                      handleAsuntoMailChange(e);
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label="Contenido del correo"
                  name="contenido_correo"
                  rules={[{ required: envioCorreo }]}
                >
                  <TextArea
                    onChange={(e) => {
                      handleMailBodyChange(e);
                    }}
                  />
                </Form.Item>
              </Col>
            </>
          )}
        </Row>

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <>
            {!amedida && (
              <Space>
                <Button
                  type="primary"
                  size="large"
                  shape="round"
                  htmlType="submit"
                  loading={loading}
                  onClick={() => solicitado && onClick()}
                >
                  {!solicitado ? 'Cotizar' : 'Cargar nueva'}
                </Button>
              </Space>
            )}
            {amedida && (
              <Space>
                <Button
                  style={{ margin: 10 }}
                  disabled={loading}
                  onClick={() => goBack()}
                >
                  Anterior
                </Button>

                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  onClick={() => solicitado && onClick()}
                >
                  {empresaTieneSms
                    ? `Enviar cotización`
                    : `Continuar con la Solicitud`}
                </Button>
              </Space>
            )}
          </>
        </div>
      </Card>
    </Form>
  );
};

const ZonaForm = React.memo(
  ({
    producto,
    departamentoMostrado,
    warningDepartamento,
    onChangeDepartamento,
    departamentos,
    onChangeDistrito,
    distritoMostrado,
    warningDistrito,
    loadingDistritos,
    distritos,
    ubicacionMostrada,
    zonaHabilitada,
    onZonaHabilitadaChange,
    debounceDireccionChange,
    zoomMap,
    zonas,
    marker,
    onClick,
    tieneAutorizacionZonaPorTipo,
    autorizaciones,
    zonasEmpresa,
    empresa,
    zonasAseguradoras,
    aseguradoras
  }) => {
    return (
      <>
        <Form.Item noStyle shouldUpdate>
          <div style={{ paddingTop: 20 }}>
            {Number(producto) === 1 ? (
              <Subtitle>Zona principal de circulación</Subtitle>
            ) : (
              <Subtitle>Datos básicos de la ubicación</Subtitle>
            )}
            <p>
              Estos datos serán utilizados para validar condiciones y costos de
              la/s aseguradora/s
            </p>
            <Card
              style={{
                textAlign: 'left',
                maxWidth,
                margin: 'auto',
                boxShadow: 'none'
              }}
            >
              <Row gutter={[16, 0]}>
                <Form.Item noStyle shouldUpdate>
                  {() => {
                    return (
                      departamentoMostrado && (
                        <Col xs={24} md={12} align="start">
                          <Form.Item
                            label="Departamento"
                            name="departamento"
                            rules={[
                              {
                                required: true
                              }
                            ]}
                            validateStatus={
                              warningDepartamento ? 'warning' : undefined
                            }
                            help={warningDepartamento}
                          >
                            <Select
                              showSearch
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              style={{
                                width: '100%'
                              }}
                              optionFilterProp="children"
                              placeholder="Elegir departamento"
                              onChange={onChangeDepartamento}
                            >
                              {departamentos?.map((item) => (
                                <Option key={item.id} value={item.id}>
                                  {item.descripcion}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      )
                    );
                  }}
                </Form.Item>
                <Form.Item noStyle shouldUpdate>
                  {() =>
                    distritoMostrado && (
                      <Col xs={24} md={12} align="start">
                        <Form.Item
                          label="Ciudad"
                          name="distrito"
                          validateStatus={
                            warningDistrito ? 'warning' : undefined
                          }
                          help={warningDistrito}
                          rules={[
                            {
                              required: true
                            }
                          ]}
                        >
                          <Select
                            labelInValue
                            showSearch
                            loading={loadingDistritos}
                            notFoundContent={
                              <NotFoundContentLoading
                                loading={loadingDistritos}
                              />
                            }
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            style={{
                              width: '100%'
                            }}
                            placeholder="Elegir distrito"
                            onChange={onChangeDistrito}
                          >
                            {distritos?.map((item) => (
                              <Option key={item.id} value={item.id}>
                                {item.descripcion}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                    )
                  }
                </Form.Item>
                {(Number(producto) === 4 ||
                  Number(producto) === 5 ||
                  Number(producto) === 6) &&
                  ubicacionMostrada && (
                    <>
                      <Col xs={24} md={24} align="start">
                        <Button
                          type="link"
                          icon={<EnvironmentOutlined />}
                          onClick={() =>
                            onZonaHabilitadaChange(!zonaHabilitada)
                          }
                          style={{
                            paddingLeft: 0
                          }}
                        >
                          {!zonaHabilitada
                            ? 'Ubicar en el mapa (opcional)'
                            : 'Omitir ubicación (opcional)'}
                        </Button>
                        {zonaHabilitada && (
                          <>
                            <br />
                            <Form.Item
                              label="Dirección"
                              name="domicilio"
                              rules={[
                                {
                                  required: true
                                }
                              ]}
                              onChange={() => {
                                debounceDireccionChange();
                              }}
                            >
                              <Input placeholder="Ingrese un valor" />
                            </Form.Item>
                            <Form.Item
                              label="Ubicar en el mapa"
                              name="zona"
                              validateStatus={
                                warningDistrito ? 'warning' : undefined
                              }
                              help={warningDistrito}
                              rules={[
                                {
                                  required: true
                                }
                              ]}
                              valuePropName="coordenadas"
                            >
                              <MapView
                                zoom={zoomMap}
                                poligons={zonas}
                                marker={marker}
                                onClick={onClick}
                              />
                            </Form.Item>
                          </>
                        )}
                      </Col>
                      {tieneAutorizacionZonaPorTipo(
                        'POLIGONO',
                        autorizaciones
                      ) && (
                        <Col xs={24} md={12} align="start">
                          <Alert
                            message="Listado de zonas con recargo"
                            type="warning"
                            showIcon
                            description={
                              <>
                                {zonasEmpresa.length > 0 && (
                                  <>
                                    <span>Definidas para {empresa.nombre}</span>
                                    <br />
                                    <ul>
                                      {zonasEmpresa.map((item) => (
                                        <li key={item.id}>
                                          {item.descripcion_poligono}
                                        </li>
                                      ))}
                                    </ul>
                                  </>
                                )}
                                {Object.keys(zonasAseguradoras).length > 0 && (
                                  <>
                                    {Object.values(zonasAseguradoras).map(
                                      (value) => (
                                        <Fragment
                                          key={value.data.id_aseguradora}
                                        >
                                          <span>
                                            Definidas para{' '}
                                            {
                                              aseguradoras.find(
                                                (aseg) =>
                                                  aseg.id ===
                                                  value.data.id_aseguradora
                                              ).nombre
                                            }
                                          </span>
                                          <br />
                                          <ul>
                                            {value.list.map((item) => (
                                              <li key={item.id}>
                                                {item.descripcion_poligono}
                                              </li>
                                            ))}
                                          </ul>
                                        </Fragment>
                                      )
                                    )}
                                  </>
                                )}
                              </>
                            }
                          />
                        </Col>
                      )}
                    </>
                  )}
              </Row>
            </Card>
          </div>
        </Form.Item>
      </>
    );
  }
);

const CotizacionAMedida = () => {
  const location = useLocation();
  const statePassed = location.state;
  const { executeRecaptcha } = useGoogleReCaptcha();
  const myRef = useRef(null);
  const ubicacionRef = useRef(null);
  const [mail, setMail] = useState();
  const [current, setCurrent] = useState(0);
  const {
    getProductoActual,
    empresa,
    producto,
    productosTelefonicos,
    productosPresenciales
  } = useContext(EmpresaContext);
  const { user } = useContext(UserContext);
  const [solicitado, setSolicitado] = useState(false);
  const [tieneAutorizaciones, setTieneAutorizaciones] = useState(false);
  const [monedas, setMonedas] = useState();
  // const [moneda, setMoneda] = useState();
  const [monedaSelectedList, setMonedaSelectedList] = useState([]);
  const [planes, setPlanes] = useState();
  const [loadingGeneral, setLoadingGeneral] = useState(false);
  const [debouncingPlanes, setDebouncingPlanes] = useState(false);
  const [loadedPlanes, setLoadedPlanes] = useState(false);
  const [zoomMap, setZoomMap] = useState(15);
  const [marker, setMarker] = useState();
  const [planLoading, setPlanLoading] = useState(false);
  const [aseguradoras, setAseguradoras] = useState();
  const [selectedPlanesEsp, setSelectedPlanesEsp] = useState([]);
  const [selectedPlanesEst, setSelectedPlanesEst] = useState([]);
  const [selectedIndexsEsp, setSelectedIndexsEsp] = useState({});
  const [selectedIndexsEst, setSelectedIndexsEst] = useState({});
  const [montoBase, setMontoBase] = useState(0);
  const [marca, setMarca] = useState(null);
  const [modelo, setModelo] = useState(null);
  const [submodelo, setSubmodelo] = useState(null);
  const [anio, setAnio] = useState(null);
  const [monto, setMonto] = useState(0);
  const [vehiculo, setVehiculo] = useState({});
  const [anioActualizado, setAnioActualizado] = useState(false);
  const [montoMin, setMontoMin] = useState(0);
  const [montoMax, setMontoMax] = useState(0);
  const [ceroKm, setCeroKm] = useState(null);
  const [representante, setRepresentante] = useState(null);
  const [volanteCambiado, setVolanteCambiado] = useState(null);
  const [combustible, setCombustible] = useState(null);
  const [tipoUso, setTipoUso] = useState(null);
  const [tipoVenta, setTipoVenta] = useState('amedida');
  // const [planEdit, setPlanEdit] = useState();
  const planEdit = undefined;
  const [
    openPlanCoberturaItemMinMaxEditor,
    setOpenPlanCoberturaItemMinMaxEditor
  ] = useState(false);
  const [openPlanEditor, setOpenPlanEditor] = useState(false);
  const [planCoberturaItemEdit, setPlanCoberturaItemEdit] = useState();
  const [loading, setLoading] = useState(false);
  const [contador, setContador] = useState(0);
  const [cotizaciones, setCotizaciones] = useState([]);
  // const [cotizacionesWithVigencia, setCotizacionesWithVigencia] = useState();
  const [vigenciaSugeridaConfig, setVigenciaSugeridaConfig] = useState();
  const [loadedVigenciaSugerida, setLoadedVigenciaSugerida] = useState();
  const [productoActual, setProductoActual] = useState();
  const [loadingInicial, setLoadingInicial] = useState();

  const { actualizarTexto } = useContext(WhatsAppContext);
  const history = useHistory();
  const [
    validacionByAseguradoraList,
    setValidacionByAseguradoraList
  ] = useState([]);
  const [mostrarValidaciones, setMostrarValidaciones] = useState(false);
  const [form] = Form.useForm();
  const [departamento, setDepartamento] = useState(null);
  const [zonas, setZonas] = useState([]);
  const [zonasEmpresa, setZonasEmpresa] = useState([]);
  const [reajuste, setReajuste] = useState(0);
  const [zonasAseguradoras, setZonasAseguradoras] = useState({});
  const [autorizaciones, setAutorizaciones] = useState([]);
  const [subcoberturasParaExcluir, setSubcoberturasParaExcluir] = useState(
    null
  );
  const [controlFranquicias, setControlFranquicias] = useState(null);
  const [vigencia, setVigencia] = useState();
  const [warningDistrito, setWarningDistrito] = useState();
  const [warningDepartamento, setWarningDepartamento] = useState();
  const [zonaHabilitada, setZonaHabilitada] = useState(false);
  const [tokenGenerado, setTokenGenerado] = useState();
  const [vigenciaByAseguradoraList, setVigenciaByAseguradoraList] = useState([
    defaultVigencia
  ]);
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState();
  const [sucursales, setSucursales] = useState();
  const [departamentoMostrado, setDepartamentoMostrado] = useState();
  const [distritoMostrado, setDistritoMostrado] = useState();
  const [ubicacionMostrada, setUbicacionMostrada] = useState();
  const [otrosHabilitados, setOtrosHabilitados] = useState(false);
  const [mostrarPasoEdicion, setmostrarPasoEdicion] = useState();
  const [actividades, setActividades] = useState([]);
  const [actividadDetalles, setActividadDetalles] = useState([]);
  const [
    cotizacionMasivaPersonaList,
    setCotizacionMasivaPersonaList
  ] = useState([]);
  const [comisionesAseguradora, setComisionesAseguradora] = useState([]);
  const [comisionesAEP, setComisionesAEP] = useState([]);
  const [envioSms, setEnvioSms] = useState(false);
  const [envioCorreo, setEnvioCorreo] = useState(false);
  const [textoSms, setTextoSms] = useState('');
  const [textoBodyMail, setTextoBodyMail] = useState('');
  const [asuntoMail, setAsuntoMail] = useState('');
  const [campañaName, setCampañaName] = useState('');
  const [visibleSectorPlanes, setVisibleSectorPlanes] = useState(false);

  const { collapsed } = useContext(SessionContext);
  const screens = useBreakpoint();
  const marginLeftPrincipal = screens && screens.md === true && 50;
  const marginRightPrincipal = screens && screens.md === true && 10;
  const maxWidthHoja =
    screens &&
    screens.md === true &&
    maxWidth + marginLeftPrincipal + marginRightPrincipal;

  let marginLeft = 0;
  if (collapsed !== undefined && screens.md === true) {
    marginLeft = collapsed ? 80 / 2 : 300 / 2;
  }

  const onZonaHabilitadaChange = (value) => {
    setZonaHabilitada(value);
    const departamentoForm = form.getFieldValue('departamento');
    const distrito = form.getFieldValue('distrito')?.value;
    const zona = form.getFieldValue('zona');
    const domicilio = form.getFieldValue('domicilio');
    const establecimientoField = form.getFieldValue('tipo_establecimiento');
    const actividadField = form.getFieldValue('rubro');

    getPlanesListo({
      vehiculo,
      reajuste,
      ...(vigencia || {}),
      ...(departamentoForm ? { departamento: { id: departamentoForm } } : {}),
      ...(distrito ? { distrito: { id: distrito } } : {}),
      ...(zona ? { zona } : {}),
      ...(domicilio ? { domicilio } : {}),
      zonaHabilitada: value,
      ...(actividadField ? { actividad: actividadField } : {}),
      ...(establecimientoField ? { establecimiento: establecimientoField } : {})
    });
  };

  const onDomicilioChange = (value, zonaEncontrada) => {
    const departamentoForm = form.getFieldValue('departamento');
    const distrito = form.getFieldValue('distrito')?.value;
    const zona = zonaEncontrada || form.getFieldValue('zona');
    const establecimientoField = form.getFieldValue('tipo_establecimiento');
    const actividadField = form.getFieldValue('rubro');
    getPlanesListo({
      vehiculo,
      reajuste,
      ...(vigencia || {}),
      ...(departamentoForm ? { departamento: { id: departamentoForm } } : {}),
      ...(distrito ? { distrito: { id: distrito } } : {}),
      ...(zona ? { zona } : {}),
      domicilio: value,
      zonaHabilitada,
      ...(actividadField ? { actividad: actividadField } : {}),
      ...(establecimientoField ? { establecimiento: establecimientoField } : {})
    });
  };

  const configurarMonedas = useCallback(
    (planesParam) => {
      const monedasConfiguradas = {};
      planesParam.forEach((item) => {
        monedasConfiguradas[item.moneda.codigo] = item.moneda;
      });
      setMonedas(Object.values(monedasConfiguradas));
      const monedaGuaranies = Object.values(monedasConfiguradas).find(
        (item) => item.codigo === 'gs'
      );
      if (monedaSelectedList.length === 0) {
        if (monedaGuaranies) {
          setMonedaSelectedList([monedaGuaranies]);
        } else {
          const codigoPrimeraMoneda = Object.keys(monedasConfiguradas)[0];
          setMonedaSelectedList([monedasConfiguradas[codigoPrimeraMoneda]]);
        }
      }
      return Object.keys(monedasConfiguradas);
    },
    [monedaSelectedList.length]
  );

  const tieneAutorizacionZonaPorTipo = (subtipo, autorizacionesParam) => {
    return autorizacionesParam.some((item) =>
      item.configs.some((config) => {
        if (
          config.tipo_validacion === 'ZONA' &&
          config.cP &&
          config.cP.length > 0
        ) {
          if (subtipo === 'DEPARTAMENTO') {
            return config.cP.some(
              (control) => control.id_departamento && !control.eliminado
            );
          }
          if (subtipo === 'DISTRITO') {
            return config.cP.some(
              (control) => control.id_distrito && !control.eliminado
            );
          }
          if (subtipo === 'POLIGONO') {
            return config.cP.some(
              (control) => control.poligono && !control.eliminado
            );
          }
        }
        return false;
      })
    );
  };

  const tienePlanControlProductoZonaPorTipo = (subtipo, planesParam) => {
    let controlesPorPlan = false;
    if (planesParam) {
      controlesPorPlan = planesParam.some(
        (item) =>
          item.controles?.length > 0 &&
          item.controles.some(
            (control) =>
              ((control.id_departamento && subtipo === 'DEPARTAMENTO') ||
                (control.id_distrito && subtipo === 'DISTRITO') ||
                (control.poligono && subtipo === 'POLIGONO')) &&
              control.eliminado !== true
          )
      );
      return controlesPorPlan;
    }
    return false;
  };

  const updateSucursalSeleccionada = (sucursal) => {
    setSucursalSeleccionada(
      sucursales.find((item) => item.id === Number(sucursal))
    );
    setSelectedIndexsEst({});
    setSelectedIndexsEsp({});
    updateSelectedPlanes({}, {}, cotizaciones);
  };

  const SucursalSelector = () => {
    return (
      <Row>
        <Col xs={24}>
          <Select
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            style={{ width: '100%' }}
            optionFilterProp="children"
            placeholder="Seleccionar sucursal"
            value={`${sucursalSeleccionada?.id}`}
            onChange={updateSucursalSeleccionada}
          >
            {sucursales.map((item) => (
              <Option key={`${item.codigo}`} value={`${item.id}`}>
                {`${item.codigo} - ${item.descripcion}`}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
    );
  };

  const filterSucursalPlan = (listaPlanes) => {
    return listaPlanes.filter(
      (plan) => plan.id_sucursal === sucursalSeleccionada?.id
    );
  };

  const filterSucursal = useCallback(
    (listaPlanes) => {
      if (!listaPlanes) {
        return listaPlanes;
      }
      const nuevaListaCotizacion = [];
      listaPlanes.forEach((item) => {
        const nuevaListaPlanes = [];
        if (item.planes) {
          item.planes.forEach((plan) => {
            if (
              (plan.id_sucursal &&
                plan.id_sucursal === sucursalSeleccionada?.id) ||
              !plan.id_sucursal
            ) {
              nuevaListaPlanes.push(plan);
            }
          });
          const cotizacionActual = { ...item, planes: nuevaListaPlanes };
          nuevaListaCotizacion.push(cotizacionActual);
        }
      });

      return nuevaListaCotizacion;
    },
    [sucursalSeleccionada?.id]
  );

  const onInitVigenciaForm = (vigenciaForm) => {
    const soloCambioMostrarForm =
      isEqual(
        omit(vigencia, ['mostrarForm', 'vigenciasHabilitadas']),
        omit(vigenciaForm, ['mostrarForm', 'vigenciasHabilitadas'])
      ) && vigencia.mostrarForm !== vigenciaForm.mostrarForm;
    setVigencia(vigenciaForm);

    if (!soloCambioMostrarForm) {
      const departamentoForm = form.getFieldValue('departamento');
      const distrito = form.getFieldValue('distrito')?.value;
      const zona = form.getFieldValue('zona');
      const domicilio = form.getFieldValue('domicilio');
      const establecimientoField = form.getFieldValue('tipo_establecimiento');
      const actividadField = form.getFieldValue('rubro');
      getPlanesListo({
        vehiculo,
        reajuste,
        ...vigenciaForm,
        ...(departamentoForm ? { departamento: { id: departamentoForm } } : {}),
        ...(distrito ? { distrito: { id: distrito } } : {}),
        ...(zona ? { zona } : {}),
        ...(domicilio ? { domicilio } : {}),
        ...(actividadField ? { actividad: actividadField } : {}),
        ...(establecimientoField
          ? { establecimiento: establecimientoField }
          : {}),
        zonaHabilitada
      });
    }
  };

  const cleanMontos = () => {
    setMontoMin(0);
    setMonto(0);
    onMontoChange(0);
    setTimeout(() => {
      setMontoMax(0);
    }, 300);
  };

  const updateMontoFromSubmodelo = (value) => {
    const selectedAnio = submodelos.find((item) => item.id === value)?.anios[0];
    if (selectedAnio) {
      updateMonto(selectedAnio);
    } else {
      cleanMontos();
    }
  };

  const formatearAMillones = (montoParam) => {
    const zeroCount = 6;
    // eslint-disable-next-line no-restricted-properties
    return Math.round(parseInt(montoParam) / Math.pow(10, zeroCount)) * 1000000;
  };

  const updateMonto = (nuevoMonto) => {
    const montoMinUpdate = Math.round(
      parseInt(nuevoMonto.monto_min) * (representante ? 0.85 : 0.65)
    ); // 15%, 35%
    const montoMaxUpdate = nuevoMonto.monto_max;
    const montoUpdate = nuevoMonto.monto_min;
    // setMonto(parseInt(fileData.anio.monto));
    setMontoMin(formatearAMillones(montoMinUpdate));
    setMontoMax(formatearAMillones(montoMaxUpdate));
    setMonto(formatearAMillones(montoUpdate));
    onMontoChange(formatearAMillones(montoUpdate));
    setMontoBase(parseInt(nuevoMonto.monto_min));
  };

  const mostrarVehiculoCero = ({ value, importacionSelected }) => {
    const selectedAnio = submodelos.find((item) => item.id === value)?.anios[0];
    if (selectedAnio) {
      const anioActual = new Date().getFullYear();
      if (selectedAnio.codigo >= anioActual && !importacionSelected) {
        setAnioActualizado(true);
      } else {
        setAnioActualizado(false);
      }
    }
  };

  const handleTipoUsoChange = (e) => {
    const selectedTipoUso = e.target.value;
    if (selectedTipoUso === 'OTROS') {
      setOtrosHabilitados(true);
    } else {
      setOtrosHabilitados(false);
    }
  };

  const representanteChange = (representanteParam) => {
    if (montoBase) {
      const montoMinRepresentante = Math.round(
        parseInt(montoBase) * (representanteParam ? 0.85 : 0.65)
      ); // 15%, 35%
      if (submodelo) {
        setMontoMin(formatearAMillones(montoMinRepresentante));
        if (monto <= montoMinRepresentante) {
          setMonto(montoMinRepresentante);
          onMontoChange(montoMinRepresentante);
        }
      } else {
        cleanMontos();
      }
    }
    setRepresentante(representanteParam);
  };

  const actualizarTextoWhatsApp = (values) => {
    const { nombres, celular } = values;
    actualizarTexto(
      `Nombre: ${nombres || ''}. \nContacto: ${celular || ''}. \n`
    );
  };

  const scrollTop = () => scrollToRef(myRef);
  const planPerteneceAseguradora = (plan, moneda, idAseguradora) => {
    return (
      plan.moneda.codigo === moneda.codigo &&
      plan.aseguradoraProducto.id_aseguradora === idAseguradora
    );
  };

  const onChangePlanSubcobertura = async (
    tipo,
    idAseguradora,
    moneda,
    idPlan,
    idCobertura,
    newSubcobertura
  ) => {
    let auxplanes;
    if (tipo === 'est') {
      auxplanes = lodashClonedeep(selectedPlanesEst);
    } else {
      auxplanes = lodashClonedeep(selectedPlanesEsp);
    }
    try {
      const plan = auxplanes.find((item) => item.id === idPlan);

      const i = plan.planSubcobertura.findIndex(
        (item) => item.subcobertura?.cobertura?.id === idCobertura
      );

      const planSubcoberturaNew = [...plan.planSubcobertura];

      planSubcoberturaNew[i] = {
        ...planSubcoberturaNew[i],
        id_subcobertura: newSubcobertura.id,
        subcobertura: newSubcobertura
      };

      let newPlan = {
        ...plan,
        producto,
        monto_total: plan.monto_total || '0',
        titulo: plan.titulo,
        datosExtra: {
          ...plan.datosExtra,
          sumaAsegurada: plan.datosExtra?.sumaAsegurada || '',
          importacion: !plan.datosExtra?.representante
        },
        moneda,
        planSubcobertura: planSubcoberturaNew,
        producto_cerrado: plan.producto_cerrado ? plan.producto_cerrado : false,
        aplica_formula: plan.aplica_formula,
        aplica_descuento: plan.aplica_descuento,
        tasa_config: plan.tasa_config,
        tasa_pura: plan.tasa_pura,
        costo_minimo: plan.costo_minimo,
        monto_contado_final: plan.monto_contado_final,
        montos: plan.montos,
        franquicia_opcion: plan.franquicia_opcion || null,
        franquicia_criterio: plan.franquicia_criterio || null,
        franquicia_monto: plan.franquicia_monto || 0,
        franquicia_descripcion: plan.franquicia_descripcion || null,
        franquicia_costo_min: plan.franquicia_costo_min || 0,
        franquicia_costo_max: plan.franquicia_costo_max || 0,
        franquicia_config: plan.franquicia_config
          ? {
              value: plan.franquicia_config.parcial_franquicia,
              label: `(${plan.franquicia_config.parcial_franquicia}) ${
                plan.franquicia_config.tipo_franquicia === 'F'
                  ? plan.franquicia_config.franquicia || '0'
                  : plan.franquicia_config.franquicia +
                    plan.franquicia_config.descripcion
              }`,
              data: plan.franquicia_config || {}
            }
          : {}
      };

      const indexPlan = auxplanes.findIndex((item) => item.id === idPlan);
      newPlan = await updatePlan(newPlan);
      auxplanes[indexPlan] = newPlan;

      if (tipo === 'est') {
        setSelectedPlanesEst(auxplanes);
      } else {
        setSelectedPlanesEsp(auxplanes);
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  const onDeleteCobertura = async (
    idCobertura,
    tipo,
    idAseguradora,
    moneda
  ) => {
    let auxplanes;
    if (tipo === 'est') {
      auxplanes = lodashClonedeep(selectedPlanesEst);
    } else {
      auxplanes = lodashClonedeep(selectedPlanesEsp);
    }
    for (let i = 0; i < auxplanes.length; i += 1) {
      if (planPerteneceAseguradora(auxplanes[i], moneda, idAseguradora)) {
        for (let j = 0; j < auxplanes[i].planSubcobertura.length; j += 1) {
          if (
            auxplanes[i].planSubcobertura[j].subcobertura.id_cobertura ===
            idCobertura
          ) {
            auxplanes[i].planSubcobertura.splice(j, 1);
          }
        }
      }
    }
    try {
      setPlanLoading(true);
      const departamentoForm = form.getFieldValue('departamento');
      const distrito = form.getFieldValue('distrito')?.value;
      const zona = form.getFieldValue('zona');
      let vehiculoParam;
      if (producto === 1) {
        vehiculoParam = vehiculo;
        if (vehiculoParam) {
          vehiculoParam.marca = marca;
          vehiculoParam.modelo = modelo;
          vehiculoParam.submodelo = submodelo;
          vehiculoParam.anio = anio;
          vehiculoParam.combustible = combustible;
          vehiculoParam.tipo_uso = tipoUso;
        }
      }
      const planesParaActualizar = [];
      for (let i = 0; i < auxplanes.length; i += 1) {
        const plan = auxplanes[i];
        if (planPerteneceAseguradora(plan, moneda, idAseguradora)) {
          planesParaActualizar.push(plan);
        }
      }

      const planesActualizados = await instanceRef.instance.post(
        `/plan/calculo/autorizacion`,
        {
          planes: planesParaActualizar,
          tipoVenta,
          reajuste,
          ...(vigencia || {}),
          ...(departamentoForm
            ? { departamento: { id: departamentoForm } }
            : {}),
          ...(distrito ? { distrito: { id: distrito } } : {}),
          ...(zona ? { zona } : {}),
          vehiculo: vehiculoParam
        }
      );

      let indicePlanActualizado = 0;
      for (let i = 0; i < auxplanes.length; i += 1) {
        const plan = auxplanes[i];
        if (planPerteneceAseguradora(plan, moneda, idAseguradora)) {
          // eslint-disable-next-line no-param-reassign
          auxplanes[i] = planesActualizados.data.data[indicePlanActualizado];
          indicePlanActualizado += 1;
        }
      }

      if (tipo === 'est') {
        setSelectedPlanesEst(auxplanes);
      } else {
        setSelectedPlanesEsp(auxplanes);
      }
      setPlanLoading(false);
    } catch (error) {
      errorHandler(error);
    }
  };

  // Se comenta (y no se borra) esta función considerando la complejidad de la misma y teniendo en cuenta que será
  // utilizada nuevamente en la brevedad posible
  // const agregarPlanEspecifico = (idAseguradora, planid, moneda) => {
  //   let auxplanes = lodashClonedeep(selectedPlanesEsp);
  //   auxplanes = auxplanes.filter(
  //     (item) =>
  //       item.aseguradoraProducto.id_aseguradora === idAseguradora &&
  //       item.id_moneda === moneda.id
  //   );
  //   let plan;
  //   if (planid) {
  //     plan = auxplanes.find((item) => item.id === planid);
  //   } else {
  //     plan =
  //       auxplanes[
  //         auxplanes.filter(
  //           (item) => item.aseguradoraProducto.id_aseguradora === idAseguradora
  //         ).length - 1
  //       ];
  //   }
  //   if (producto === 1) {
  //     onPlanEditFinishEspecifico(idAseguradora, null, plan);
  //   } else {
  //     setPlanEdit({
  //       idAseguradora,
  //       idPlan: plan.id,
  //       update: !!planid,
  //       producto: { codigo: producto },
  //       monto_total: plan.monto_total,
  //       titulo: plan.titulo,
  //       datosExtra: {
  //         ...plan.datosExtra,
  //         sumaAsegurada: plan.datosExtra?.sumaAsegurada || '0',
  //         importacion: !plan.datosExtra?.representante
  //       },
  //       moneda
  //     });
  //     setOpenPlanEditor(true);
  //   }
  // };

  /* const controlMinMax = (plan, montomm, i, moneda) => {
    let max;
    let min;
    const newPlan = plan;
    newPlan.planSubcobertura[i].monto = Number(montomm);
    max = plan.planSubcobertura[i].monto_max;
    min = plan.planSubcobertura[i].monto_min;
    if (!(max > 0 && min > 0)) {
      if (!max > 0) {
        max = plan.planSubcobertura[i].subcobertura.monto_max;
      }
      if (!min >= 1) {
        min = plan.planSubcobertura[i].subcobertura.monto_min;
      }
    }
    const item = plan.planSubcobertura[i];
    if (
      (item.subcobertura.opcion === 'valor_capital' &&
        plan.monto_total &&
        `${item.monto}` !== '-1' &&
        Number(montomm) !== 0) ||
      (item.subcobertura.opcion === 'valor_capital' && Number(montomm) >= 1)
    ) {
      if (montomm < min && min) {
        message.info({
          content: `El valor mínimo permitido es de ${formatoMonedaGenerico(
            moneda,
            min
          )}. Su cotización quedará sujeta a Autorización`,
          duration: 10
        });
      }
      if (montomm > max && max) {
        message.info({
          content: `El valor máximo permitido es de ${formatoMonedaGenerico(
            moneda,
            max
          )}. Su cotización quedará sujeta a Autorización`,
          duration: 10
        });
      }
    }
    return newPlan;
  }; */

  const onPlanEditFinishEspecifico = async (idAseguradora, idPlan, values) => {
    const auxPlanes = lodashClonedeep(selectedPlanesEsp);
    let plan;
    for (let index = 0; index < auxPlanes.length; index += 1) {
      if (
        auxPlanes[index].id_moneda === values.moneda.id &&
        auxPlanes[index].aseguradoraProducto.id_aseguradora === idAseguradora
      ) {
        plan = lodashClonedeep(auxPlanes[index]);
        plan.orden += 1;
      }
    }
    if (!planEdit || !planEdit.update) {
      plan = { ...plan, ...values };
      plan.id = contador - 1;
      const planSubcoberturas = plan.planSubcobertura;
      let auxcontador = contador;
      for (let index = 0; index < planSubcoberturas.length; index += 1) {
        planSubcoberturas[index].id = -1 + auxcontador;
        planSubcoberturas[index].id_plan = plan.id;
        auxcontador -= 1;
      }
      setContador(auxcontador);
      plan.planSubcobertura = planSubcoberturas;
      plan = await updatePlan(plan);
      auxPlanes.push(plan);
    }
    if (planEdit?.update) {
      let i;
      for (let index = 0; index < auxPlanes.length; index += 1) {
        if (auxPlanes[index].id === idPlan) {
          i = index;
          index = auxPlanes.length;
        }
      }
      auxPlanes[i] = { ...auxPlanes[i], ...values };
      auxPlanes[i] = await updatePlan(auxPlanes[i]);
    }

    setSelectedPlanesEsp(auxPlanes);
    setOpenPlanEditor(false);
  };

  const verificarCombustible = (id) => {
    const combustibleReconocido = reconocerCombustible(id, submodelos);
    if (combustibleReconocido) {
      form.setFieldsValue({ combustible: combustibleReconocido });
      setCombustible(combustibleReconocido);
    } else {
      form.setFieldsValue({ combustible: undefined });
      setCombustible(undefined);
    }
  };

  const onPlanEditFinish = (values) => {
    const { idAseguradora, idPlan } = planEdit;
    onPlanEditFinishEspecifico(idAseguradora, idPlan, values);
  };

  const quitarBanderaEdicion = (list) => {
    for (let indexPlan = 0; indexPlan < list.length; indexPlan += 1) {
      const plan = list[indexPlan];
      for (
        let indexCobertura = 0;
        indexCobertura < plan.planSubcobertura.length;
        indexCobertura += 1
      ) {
        const planSubcobertura = plan.planSubcobertura[indexCobertura];
        if (planSubcobertura.monto === -3 || planSubcobertura.monto === '-3') {
          planSubcobertura.monto = null;
        }
      }
    }
  };

  const enviarCotizacion = (values) => {
    const est = lodashClonedeep(selectedPlanesEst);
    const esp = lodashClonedeep(selectedPlanesEsp);
    quitarBanderaEdicion(est);
    quitarBanderaEdicion(esp);
    // const descuento =  Number(form.getFieldValue('descuento')) * signo || 0;

    const tipoVentaCotizacion = tipoVenta;

    form
      .validateFields()
      .then(async () => {
        //               const vigencia = vigenciaByAseguradoraList[0];
        if (producto === 1 && statePassed.tipoCotizacion !== 'masiva') {
          if (verificarDatos()) {
            try {
              setLoading(true);
              const reCaptchaToken = await executeRecaptcha(
                'cotizacion/enviar'
              );
              const data = {
                reCaptchaToken,
                marca: { id: marca },
                modelo: { id: modelo },
                submodelo: { id: submodelo },
                anio: {
                  id: submodelos.find((item) => item.id === submodelo).anios[0]
                    .id
                },
                monto: `${monto}`,
                combustible,
                persona: {
                  nombres: values.nombres,
                  celular: `+595${formatCelular(values.celular)}`,
                  correo: values.correo
                },
                representante: representante ? 1 : 0,
                volante_cambiado: volanteCambiado ? 1 : 0,
                nuevo: ceroKm ? 1 : 0,
                vendedor: values.vendedor,
                correoVendedor: values.correoVendedor,
                celularVendedor: values.celularVendedor
                  ? `+595${formatCelular(values.celularVendedor)}`
                  : undefined,
                idProducto: producto,
                planes: [...esp, ...est],
                tipo_venta: tipoVentaCotizacion,
                tipo_uso:
                  form.getFieldValue('tipo_uso') !== 'OTROS'
                    ? form.getFieldValue('tipo_uso')
                    : form.getFieldValue('tipo_uso_otros'),
                controles: {
                  reajuste,
                  departamento: form.getFieldValue('departamento')
                    ? Number(form.getFieldValue('departamento'))
                    : null,
                  distrito: form.getFieldValue('distrito')
                    ? Number(form.getFieldValue('distrito').value)
                    : null,
                  domicilio: form.getFieldValue('domicilio') || null,
                  zona: form.getFieldValue('zona')
                },
                vigencia: {
                  cantidad_pagos: vigencia.cantidad_pagos,
                  fechaInicioVigencia: vigencia.desde,
                  fechaFinVigencia: vigencia.hasta,
                  cantidadDias: vigencia.cantidad_dias,
                  vigencia: vigencia.vigencia,
                  id_vigencia: vigencia.vigencia && vigencia.vigencia.id,
                  frecuencia: vigencia.frecuencia,
                  id_modalidad_pago: vigencia.frecuencia.id,
                  pagos: {
                    frecuencia: vigencia.frecuencia,
                    id_modalidad_pago: vigencia.frecuencia.id,
                    cantidad_pagos: vigencia.cantidad_pagos
                  }
                }
              };

              const response = await instanceRef.instance.post(
                `cotizacion/enviar`,
                data
              );
              const { token } = response.data?.data;
              if (token && tipoVentaCotizacion === 'telefonica') {
                handleOpenUrl(`/solicitar/${token}`);
              } else if (token && tipoVentaCotizacion === 'presencial') {
                handleOpenUrl(`/solicitar/${token}`);
              }

              setTokenGenerado(token);
              setTieneAutorizaciones(
                response.data.data.autorizaciones?.length > 0
              );
              setSolicitado(true);
            } catch (error) {
              message.error('Error al enviar la solicitud');
            }
            setLoading(false);
            // ADD Route to solicitud si es telefonica
          }
        } else {
          try {
            if (statePassed.tipoCotizacion !== 'masiva') {
              setLoading(true);
              const reCaptchaToken = await executeRecaptcha(
                'cotizacion/enviar'
              );
              const dataEnviar = {
                reCaptchaToken,
                persona: {
                  nombres: values.nombres,
                  celular: `+595${formatCelular(values.celular)}`,
                  correo: values.correo
                },
                idProducto: producto,
                planes: [...esp, ...est],
                tipo_venta: tipoVentaCotizacion,
                controles: {
                  reajuste,
                  departamento: form.getFieldValue('departamento')
                    ? Number(form.getFieldValue('departamento'))
                    : null,
                  distrito: form.getFieldValue('distrito')
                    ? Number(form.getFieldValue('distrito').value)
                    : null,
                  domicilio: form.getFieldValue('domicilio') || null,
                  zona: form.getFieldValue('zona')
                },
                vigencia: {
                  cantidad_pagos: vigencia.cantidad_pagos,
                  fechaInicioVigencia: vigencia.desde,
                  fechaFinVigencia: vigencia.hasta,
                  cantidadDias: vigencia.cantidad_dias,
                  vigencia: vigencia.vigencia,
                  id_vigencia: vigencia.vigencia && vigencia.vigencia.id,
                  frecuencia: vigencia.frecuencia,
                  id_modalidad_pago: vigencia.frecuencia.id,
                  pagos: {
                    frecuencia: vigencia.frecuencia,
                    id_modalidad_pago: vigencia.frecuencia.id,
                    cantidad_pagos: vigencia.cantidad_pagos
                  }
                },
                tipo_establecimiento: form.getFieldValue(
                  'tipo_establecimiento'
                ),
                rubro: form.getFieldValue('rubro')
              };
              const response = await instanceRef.instance.post(
                `cotizacion/enviar`,
                dataEnviar
              );
              const { token } = response.data.data;
              if (token && tipoVentaCotizacion === 'telefonica') {
                handleOpenUrl(`/solicitar/${token}`);
              } else if (token && tipoVentaCotizacion === 'presencial') {
                handleOpenUrl(`/solicitar/${token}`);
              }
              setTokenGenerado(token);
              setSolicitado(true);
              setTieneAutorizaciones(
                response.data.data.autorizaciones?.length > 0
              );
            }
            if (statePassed.tipoCotizacion === 'masiva') {
              setLoading(true);
              const reCaptchaToken = await executeRecaptcha(
                'cotizacionmasiva/enviar'
              );
              const dataEnviar = {
                reCaptchaToken,
                cotizacionMasivaPersonaList,
                envioSms,
                envioCorreo,
                textoSms,
                textoBodyMail,
                asuntoMail,
                campañaName,
                idProducto: producto,
                planes: [...esp, ...est],
                tipo_venta: tipoVentaCotizacion,
                controles: {
                  reajuste,
                  departamento: form.getFieldValue('departamento')
                    ? Number(form.getFieldValue('departamento'))
                    : null,
                  distrito: form.getFieldValue('distrito')
                    ? Number(form.getFieldValue('distrito').value)
                    : null,
                  domicilio: form.getFieldValue('domicilio') || null,
                  zona: form.getFieldValue('zona')
                },
                vigencia: {
                  cantidad_pagos: vigencia.cantidad_pagos,
                  fechaInicioVigencia: vigencia.desde,
                  fechaFinVigencia: vigencia.hasta,
                  cantidadDias: vigencia.cantidad_dias,
                  vigencia: vigencia.vigencia,
                  id_vigencia: vigencia.vigencia && vigencia.vigencia.id,
                  frecuencia: vigencia.frecuencia,
                  id_modalidad_pago: vigencia.frecuencia.id,
                  pagos: {
                    frecuencia: vigencia.frecuencia,
                    id_modalidad_pago: vigencia.frecuencia.id,
                    cantidad_pagos: vigencia.cantidad_pagos
                  }
                },
                tipo_establecimiento: form.getFieldValue(
                  'tipo_establecimiento'
                ),
                rubro: form.getFieldValue('rubro')
              };
              const response = await instanceRef.instance.post(
                `cotizacionmasiva/enviar`,
                dataEnviar
              );
              const { token } = response.data.data;
              setTokenGenerado(token);
              setSolicitado(true);
              setTieneAutorizaciones(
                response.data.data.autorizaciones?.length > 0
              );
            }
          } catch (error) {
            message.error('Error al enviar la cotización');
          }
          setLoading(false);
        }
      })
      .catch(() => {
        //
      });
  };

  const onChangePlanTitleEspecifico = (event, idPlan) => {
    const nuevosPlanes = lodashClonedeep(selectedPlanesEsp);
    const plan = nuevosPlanes.find((item) => item.id === idPlan);
    const indexPlan = nuevosPlanes.findIndex((item) => item.id === idPlan);
    plan.titulo = event.target.value;
    plan.changed = true;
    nuevosPlanes[indexPlan] = plan;
    setSelectedPlanesEsp(nuevosPlanes);
  };

  const onEditPlanCoberturaMinMaxItem = (data, idEmpresa, columna) => {
    setPlanCoberturaItemEdit({
      ...data,
      idEmpresa,
      producto,
      columna
    });
    setOpenPlanCoberturaItemMinMaxEditor(true);
  };

  const onEditPlanCoberturaItemMinMaxFinish = (values) => {
    let bandera = false;
    for (let index = 0; index < selectedPlanesEst.length; index += 1) {
      if (!bandera) {
        for (
          let jindex = 0;
          jindex < selectedPlanesEst[index].planSubcobertura.length;
          jindex += 1
        ) {
          if (
            selectedPlanesEst[index].planSubcobertura[jindex].id === values.id
          ) {
            selectedPlanesEst[index].planSubcobertura[jindex] = { ...values };
            bandera = true;
            jindex = selectedPlanesEst[index].planSubcobertura.length;
          }
        }
      }
    }
    if (!bandera) {
      if (!bandera) {
        for (let index = 0; index < selectedPlanesEsp.length; index += 1) {
          for (
            let jindex = 0;
            jindex < selectedPlanesEsp[index].planSubcobertura.length;
            jindex += 1
          ) {
            if (
              selectedPlanesEsp[index].planSubcobertura[jindex].id === values.id
            ) {
              selectedPlanesEsp[index].planSubcobertura[jindex] = {
                ...values
              };
              bandera = true;
              jindex = selectedPlanesEsp[index].planSubcobertura.length;
            }
          }
        }
      }
    }
    setOpenPlanCoberturaItemMinMaxEditor(false);
  };

  const mostrarItemsFormulario = useCallback(
    (autorizacionesParam, planesParam) => {
      const mostrarItemDistrito =
        tieneAutorizacionZonaPorTipo('DISTRITO', autorizacionesParam) ||
        tienePlanControlProductoZonaPorTipo('DISTRITO', planesParam);
      if (mostrarItemDistrito) {
        setDistritoMostrado(true);
      }
      const mostrarItemDepartamento =
        tieneAutorizacionZonaPorTipo('DEPARTAMENTO', autorizacionesParam) ||
        tieneAutorizacionZonaPorTipo('DISTRITO', autorizacionesParam) ||
        tienePlanControlProductoZonaPorTipo('DEPARTAMENTO', planesParam) ||
        tienePlanControlProductoZonaPorTipo('DISTRITO', planesParam);
      if (mostrarItemDepartamento) {
        setDepartamentoMostrado(true);
      } else {
        setDepartamentoMostrado(false);
      }
      const mostrarItemUbicacion =
        tieneAutorizacionZonaPorTipo('POLIGONO', autorizacionesParam) ||
        tienePlanControlProductoZonaPorTipo('POLIGONO', planesParam);
      if (mostrarItemUbicacion) {
        setUbicacionMostrada(true);
      }
    },
    []
  );

  const verificarAutorizaciones = useCallback(
    async (estandares, especificos) => {
      try {
        let planesAVerificar = [...estandares, ...especificos];
        if (planesAVerificar.length <= 0) {
          setAutorizaciones([]);
          setLoadingGeneral(false);
          return {};
        }
        if (
          isEqual(selectedPlanesEst, estandares) &&
          isEqual(selectedPlanesEsp, especificos)
        ) {
          setAutorizaciones([]);
          setLoadingGeneral(false);
          return {};
        }

        planesAVerificar = planesAVerificar.filter(
          (item) => item !== null && item !== undefined
        );
        setLoadingGeneral(true);
        const response = await instanceRef.instance.post(
          `autorizacion/config/consultar`,
          {
            planes: planesAVerificar
          }
        );
        if (response.data?.data) {
          setAutorizaciones(response.data.data);
          mostrarItemsFormulario(response.data.data, planesAVerificar);

          response.data.data.forEach((item) => {
            item.configs.forEach((config) => {
              const { cP } = config;
              if (cP?.length > 0) {
                const controlesZona = cP.filter((el) => el.poligono);
                if (controlesZona.length > 0) {
                  // Zonas definidas por la empresa
                  const existe = zonasEmpresa.some(
                    (el) =>
                      el.id_autorizacion_config ===
                      controlesZona[0].id_autorizacion_config
                  );
                  if (config.id_empresa_producto && !existe) {
                    setZonasEmpresa([...zonasEmpresa, ...controlesZona]);
                  }

                  // Zonas definidas por la Aseguradora
                  if (config.aseguradoraProducto?.id_aseguradora) {
                    const existePorAseguradora = zonasAseguradoras[
                      config.aseguradoraProducto.id_aseguradora
                    ]?.list.some(
                      (el) =>
                        el.id_autorizacion_config ===
                        controlesZona[0].id_autorizacion_config
                    );
                    if (!existePorAseguradora) {
                      const nuevo = { ...zonasAseguradoras };
                      if (nuevo[config.aseguradoraProducto.id_aseguradora]) {
                        nuevo[
                          config.aseguradoraProducto.id_aseguradora
                        ].list = [...nuevo.list, ...controlesZona];
                      } else {
                        nuevo[config.aseguradoraProducto.id_aseguradora] = {
                          data: config.aseguradoraProducto,
                          list: controlesZona
                        };
                      }
                      setZonasAseguradoras(nuevo);
                    }
                  }
                  // Zonas definidas por la Aseguradora para la Empresa
                  if (
                    config.aseguradoraEmpresaProducto?.aseguradoraEmpresa
                      ?.id_aseguradora
                  ) {
                    const existePorAseguradora = zonasAseguradoras[
                      config.aseguradoraEmpresaProducto.aseguradoraEmpresa
                        .id_aseguradora
                    ]?.list.some(
                      (el) =>
                        el.id_autorizacion_config ===
                        controlesZona[0].id_autorizacion_config
                    );
                    if (!existePorAseguradora) {
                      const nuevo = { ...zonasAseguradoras };
                      if (
                        nuevo[
                          config.aseguradoraEmpresaProducto.aseguradoraEmpresa
                            .id_aseguradora
                        ]
                      ) {
                        nuevo[
                          config.aseguradoraEmpresaProducto.aseguradoraEmpresa.id_aseguradora
                        ].list = [...nuevo.list, ...controlesZona];
                      } else {
                        nuevo[
                          config.aseguradoraEmpresaProducto.aseguradoraEmpresa.id_aseguradora
                        ] = {
                          data:
                            config.aseguradoraEmpresaProducto
                              .aseguradoraEmpresa,
                          list: controlesZona
                        };
                      }
                      setZonasAseguradoras(nuevo);
                    }
                  }
                }
              }
            });
          });
          const reduced = response.data.data.reduce((filtered, option) => {
            if (option.controles.some((item) => item.poligono)) {
              filtered.push(option);
            }
            return filtered;
          }, []);

          setZonas(
            reduced.map(({ id, descripcion_poligono: descripcion }) => ({
              id,
              descripcion
            }))
          );
        }
        setLoadingGeneral(false);
        return response.data.data;
      } catch (err) {
        setLoadingGeneral(false);
        errorHandler(err);
        return {};
      }
    },
    [
      selectedPlanesEst,
      selectedPlanesEsp,
      mostrarItemsFormulario,
      zonasEmpresa,
      zonasAseguradoras
    ]
  );

  const updateSelectedPlanes = React.useCallback(
    (selectedIndexsEstParam, selectedIndexsEspParam, cotizacionesParam) => {
      const planesNuevosEst = [];
      Object.entries(selectedIndexsEstParam).forEach(([key, value]) => {
        const planesCotizacion = filterSucursal(cotizacionesParam).find(
          (item) => item.id === Number(key)
        );
        if (planesCotizacion) {
          Object.entries(value).forEach(([keyMoneda, valueMoneda]) => {
            const planesPorMoneda = planesCotizacion.planes.filter(
              (item) => item.moneda.codigo === keyMoneda && !item.id_sucursal
            );
            // if (planesPorMoneda && planesPorMoneda.length > 0) {
            //   valueMoneda.forEach((plan) =>
            //     planesNuevosEst.push(planesPorMoneda[plan])
            //   );
            // }
            valueMoneda.forEach((plan) => {
              const planesPorComision = planesPorMoneda?.filter(
                (item) => item.id_comision_aseguradora === plan[0]
              );
              if (planesPorComision && planesPorComision.length > 0) {
                planesNuevosEst.push(planesPorComision[plan[1]]);
              }
            });
          });
        }
      });
      setSelectedPlanesEst(planesNuevosEst);
      const planesNuevosEsp = [];

      Object.entries(selectedIndexsEspParam).forEach(([key, value]) => {
        const planesCotizacion = filterSucursal(cotizacionesParam).find(
          (item) => item.id === Number(key)
        );

        if (planesCotizacion) {
          Object.entries(value).forEach(([keyMoneda, valueMoneda]) => {
            const planesPorMoneda = planesCotizacion.planes?.filter(
              (item) => item.moneda.codigo === keyMoneda && item.id_sucursal
            );
            // valueMoneda -> En la posicion 0 esta el idComision, y en la posicion 1 se encuentra el indice de la columna seleccionada
            valueMoneda.forEach((plan) => {
              const planesPorComision = planesPorMoneda?.filter(
                (item) => item.id_comision_aseguradora === plan[0]
              );
              if (planesPorComision && planesPorComision.length > 0) {
                planesNuevosEsp.push(planesPorComision[plan[1]]);
              }
            });
          });
        }
      });
      setSelectedPlanesEsp(planesNuevosEsp);
    },
    [filterSucursal]
  );

  const updatePlanes = async (newmonto, fila, tipo, moneda) => {
    let auxplanes;
    if (tipo === 'est') {
      auxplanes = lodashClonedeep(selectedPlanesEst);
    } else {
      auxplanes = lodashClonedeep(selectedPlanesEsp);
    }
    let i;
    let j;
    for (let indexi = 0; indexi < auxplanes.length; indexi += 1) {
      for (
        let indexj = 0;
        indexj < auxplanes[indexi].planSubcobertura.length;
        indexj += 1
      ) {
        if (auxplanes[indexi].planSubcobertura[indexj].id === fila) {
          i = indexi;
          j = indexj;
        }
      }
    }
    if (i >= 0 && j >= 0) {
      const newplan = controlMinMax(auxplanes[i], newmonto, j, moneda);
      auxplanes[i] = newplan;
    }
    try {
      setPlanLoading({ ...planLoading, [auxplanes[i].id]: true });
      const departamentoForm = form.getFieldValue('departamento');
      const distrito = form.getFieldValue('distrito')?.value;
      const zona = form.getFieldValue('zona');
      let vehiculoParam;
      if (producto === 1) {
        vehiculoParam = vehiculo;
        if (vehiculoParam) {
          vehiculoParam.marca = marca;
          vehiculoParam.modelo = modelo;
          vehiculoParam.submodelo = submodelo;
          vehiculoParam.anio = anio;
          vehiculoParam.combustible = combustible;
          vehiculoParam.tipo_uso = tipoUso;
        }
      }

      const response = await instanceRef.instance.post(
        `/plan/calculo/autorizacion`,
        {
          planes: [auxplanes[i]],
          tipoVenta,
          reajuste,
          ...(vigencia || {}),
          ...(departamentoForm
            ? { departamento: { id: departamentoForm } }
            : {}),
          ...(distrito ? { distrito: { id: distrito } } : {}),
          ...(zona ? { zona } : {}),
          vehiculo: vehiculoParam
        }
      );
      auxplanes[i] = { ...auxplanes[i], ...response.data.data[0] };
      setPlanLoading({ ...planLoading, [auxplanes[i].id]: false });
    } catch (error) {
      setPlanLoading({ ...planLoading, [auxplanes[i].id]: false });

      errorHandler(error);
    }
    if (tipo === 'est') {
      setSelectedPlanesEst(auxplanes);
    } else {
      setSelectedPlanesEsp(auxplanes);
    }
  };

  const updatePlan = async (planParam) => {
    let planActualizado = { ...planParam };
    try {
      setPlanLoading({ ...planLoading, [planParam.id]: true });
      const departamentoForm = form.getFieldValue('departamento');
      const distrito = form.getFieldValue('distrito')?.value;
      const zona = form.getFieldValue('zona');
      let vehiculoParam;
      if (producto === 1) {
        vehiculoParam = vehiculo;
        if (vehiculoParam) {
          vehiculoParam.marca = marca;
          vehiculoParam.modelo = modelo;
          vehiculoParam.submodelo = submodelo;
          vehiculoParam.anio = anio;
          vehiculoParam.combustible = combustible;
          vehiculoParam.tipo_uso = tipoUso;
        }
      }
      const response = await instanceRef.instance.post(
        `/plan/calculo/autorizacion`,
        {
          planes: [planParam],
          tipoVenta,
          reajuste,
          ...(vigencia || {}),
          ...(departamentoForm
            ? { departamento: { id: departamentoForm } }
            : {}),
          ...(distrito ? { distrito: { id: distrito } } : {}),
          ...(zona ? { zona } : {}),
          vehiculo: vehiculoParam
        }
      );
      planActualizado = { ...planParam, ...response.data.data[0] };
      setPlanLoading({ ...planLoading, [planParam.id]: false });
    } catch (error) {
      setPlanLoading({ ...planLoading, [planParam.id]: false });
      errorHandler(error);
    }
    return planActualizado;
  };

  const validarPlanes = () => {
    // Validacion para coberturas con tipo sumaTablaOVP y sumaTablaRC
    let planesValidados = true;
    const planesEst = lodashClonedeep(selectedPlanesEst);
    const planesEsp = lodashClonedeep(selectedPlanesEsp);
    const listaDePlanes = [...planesEst, ...planesEsp]; // Obs: los planes y las coberturas eliminadas ya no estan incluidas
    const listaDeSubcoberturas = listaDePlanes.flatMap(
      (plan) => plan.planSubcobertura
    );
    const planSubcoberturasFiltradas = listaDeSubcoberturas.filter(
      ({ subcobertura, monto: valueMonto }) =>
        (subcobertura.opcion === 'suma_tabla_ovp' ||
          subcobertura.opcion === 'suma_tabla_rc') &&
        (valueMonto === 0 || valueMonto === null)
    );
    const duracionMensaje = Number(7); // segundos
    for (let i = 0; i < planSubcoberturasFiltradas.length; i += 1) {
      planesValidados = false;
      const planSubcoberturasFiltrada = planSubcoberturasFiltradas[i];
      const plan = listaDePlanes.find(
        (item) => item.id === planSubcoberturasFiltrada.id_plan
      );
      const text = `${
        planSubcoberturasFiltrada?.subcobertura?.cobertura?.descripcion
      } debe ser mayor a cero ${plan.titulo ? `(${plan.titulo})` : ''}`;
      message.error(text, duracionMensaje);
    }
    return planesValidados;
  };

  const tieneComisionesDiferentes = (dataArray) => {
    const groupedData = {};

    for (const item of dataArray) {
      const { id_comision_aseguradora, id_aseguradora_empresa_producto } = item;
      if (!groupedData[id_aseguradora_empresa_producto]) {
        groupedData[id_aseguradora_empresa_producto] = new Set();
      }
      groupedData[id_aseguradora_empresa_producto].add(id_comision_aseguradora);
    }

    for (const key in groupedData) {
      if (groupedData[key].size > 1) {
        return true;
      }
    }

    return false;
  };

  const validateStep = async (step) => {
    // Validacion para planes seleccionados
    let existePlanSeleccionadoEst;
    let existePlanSeleccionadoEsp;
    const listaEspecificos = Object.keys(selectedIndexsEsp);
    if (listaEspecificos.length > 0) {
      existePlanSeleccionadoEst = listaEspecificos.some((item) => {
        const monedasSeleccionadas = Object.keys(selectedIndexsEsp[item]);
        return monedasSeleccionadas.some(
          (monedaSeleccionada) =>
            selectedIndexsEsp[item][monedaSeleccionada].length > 0
        );
      });
    }

    const listaEstandares = Object.keys(selectedIndexsEst);
    if (listaEstandares.length > 0) {
      existePlanSeleccionadoEsp = listaEstandares.some((item) => {
        const monedasSeleccionadas = Object.keys(selectedIndexsEst[item]);
        return monedasSeleccionadas.some(
          (monedaSeleccionada) =>
            selectedIndexsEst[item][monedaSeleccionada].length > 0
        );
      });
    }

    const tieneDistintasComisionesPorAsegEsp = tieneComisionesDiferentes(
      selectedPlanesEsp
    );

    const tieneDistintasComisionesPorAsegEst = tieneComisionesDiferentes(
      selectedPlanesEst
    );

    switch (step) {
      case 0:
        try {
          await form.validateFields();
        } catch (err) {
          form.scrollToField(err.errorFields[0].name, {
            behavior: (actions) => {
              if (actions && actions.length > 0) {
                const [{ el, top }] = actions;
                scrollToField(el, top);
              }
            }
          });
          message.warning('Completá todos los campos requeridos.');
          return false;
        }

        if (
          tieneDistintasComisionesPorAsegEsp ||
          tieneDistintasComisionesPorAsegEst
        ) {
          message.warning(
            'Debe seleccionar planes de un mismo rango de comisión, por tipo de producto.'
          );
          return false;
        }
        if (
          existePlanSeleccionadoEst ||
          existePlanSeleccionadoEsp ||
          (statePassed.tipoCotizacion === 'masiva' &&
            (producto === 1 || producto === 5))
        ) {
          return true;
        }
        message.warning('Debe seleccionar al menos un plan');
        return false;

      case 1:
        return validarPlanes();
      default:
        return false;
    }
  };

  /**
   * Recalcula las posiciones de los planes seleccionados cuando aparecen nuevos planes o se desaparecen (dependiendo de los controles por plan)
   * @param {*} cotizacionesParam Lista actual de cotizaciones con sus planes
   * @param {*} cotizacionesNuevasParam Lista nueva de cotizaciones con sus planes
   */
  const recalcularIndicesSeleccionados = useCallback(
    (cotizacionesParam, cotizacionesNuevasParam, monedasNuevas) => {
      // PLANES ESTANDAR
      const selectedIdsEst = { ...selectedIndexsEst };
      const selectedIndexsEstNuevos = {};
      // Se buscan los planes para guardar el id y reemplazar luego en la nueva lista
      Object.entries(selectedIndexsEst).forEach(([key, value]) => {
        const planesCotizacion = filterSucursal(cotizacionesParam).find(
          (item) => item.id === Number(key)
        );

        if (planesCotizacion) {
          Object.keys(value).forEach((keyMoneda) => {
            const planesPorMoneda = planesCotizacion.planes?.filter(
              (item) => item.moneda.codigo === keyMoneda && !item.id_sucursal
            );
            if (planesPorMoneda && planesPorMoneda.length > 0) {
              // Se reemplazan los indices por su correspondiente ID
              selectedIdsEst[key][keyMoneda] = selectedIdsEst[key][
                keyMoneda
              ].map((item) => planesPorMoneda[item].id);
            }
          });
        }
      });

      // Se crea nueva estructura segun planes existentes
      filterSucursal(cotizacionesNuevasParam).forEach((cotizacion) => {
        monedasNuevas.forEach((keyMoneda) => {
          const planesPorMoneda = cotizacion.planes?.filter(
            (item) => item.moneda.codigo === keyMoneda && !item.id_sucursal
          );

          planesPorMoneda.forEach((plan, indicePlanNuevo) => {
            const indiceEncontrado = selectedIdsEst[cotizacion.id]?.[
              keyMoneda
            ]?.findIndex((item) => item === plan.id);
            if (indiceEncontrado >= 0) {
              if (!selectedIndexsEstNuevos[cotizacion.id]) {
                selectedIndexsEstNuevos[cotizacion.id] = {};
              }
              if (!selectedIndexsEstNuevos[cotizacion.id][keyMoneda]) {
                selectedIndexsEstNuevos[cotizacion.id][keyMoneda] = [];
              }
              selectedIndexsEstNuevos[cotizacion.id][keyMoneda].push(
                indicePlanNuevo
              );
            }
          });
        });
      });

      // PLANES ESPECIFICOS
      const selectedIdsEsp = { ...selectedIndexsEsp };
      const selectedIndexsEspNuevos = {};
      // Se buscan los planes para guardar el id y reemplazar luego en la nueva lista
      Object.entries(selectedIndexsEsp).forEach(([key, value]) => {
        const planesCotizacion = filterSucursal(cotizacionesParam).find(
          (item) => item.id === Number(key)
        );

        if (planesCotizacion) {
          Object.keys(value).forEach((keyMoneda) => {
            const planesPorMoneda = planesCotizacion.planes?.filter(
              (item) => item.moneda.codigo === keyMoneda && item.id_sucursal
            );
            if (planesPorMoneda && planesPorMoneda.length > 0) {
              // Se reemplazan los indices por su correspondiente ID
              selectedIdsEsp[key][keyMoneda] = selectedIdsEsp[key][
                keyMoneda
              ].map((item) => planesPorMoneda[item].id);
            }
          });
        }
      });

      // Se crea nueva estructura segun planes existentes
      filterSucursal(cotizacionesNuevasParam).forEach((cotizacion) => {
        monedasNuevas.forEach((keyMoneda) => {
          const planesPorMoneda = cotizacion.planes?.filter(
            (item) => item.moneda.codigo === keyMoneda && item.id_sucursal
          );

          planesPorMoneda.forEach((plan, indicePlanNuevo) => {
            const indiceEncontrado = selectedIdsEsp[cotizacion.id]?.[
              keyMoneda
            ]?.findIndex((item) => item === plan.id);
            if (indiceEncontrado >= 0) {
              if (!selectedIndexsEspNuevos[cotizacion.id]) {
                selectedIndexsEspNuevos[cotizacion.id] = {};
              }
              if (!selectedIndexsEspNuevos[cotizacion.id][keyMoneda]) {
                selectedIndexsEspNuevos[cotizacion.id][keyMoneda] = [];
              }
              selectedIndexsEspNuevos[cotizacion.id][keyMoneda].push(
                indicePlanNuevo
              );
            }
          });
        });
      });

      return { selectedIndexsEstNuevos, selectedIndexsEspNuevos };
    },
    [filterSucursal, selectedIndexsEsp, selectedIndexsEst]
  );

  const getVehiculo = useCallback(
    (vigenciaParam) => {
      if (producto === 1) {
        const vehiculoParam = vigenciaParam.vehiculo;
        if (
          !vehiculoParam ||
          vehiculoParam.representante === undefined ||
          vehiculoParam.sumaAsegurada === undefined ||
          vehiculoParam.submodelo === undefined ||
          !(
            vehiculoParam.representante === true ||
            (vehiculoParam.representante === false &&
              vehiculoParam.volante_cambiado !== undefined)
          ) ||
          !(
            anioActualizado === false ||
            (anioActualizado === true && vehiculoParam.ceroKm !== undefined)
          )
        ) {
          return undefined;
        }
        if (vehiculoParam) {
          vehiculoParam.marca = marca;
          vehiculoParam.modelo = modelo;
          vehiculoParam.submodelo = submodelo;
          vehiculoParam.anio = anio;
          vehiculoParam.combustible = combustible;
          vehiculoParam.tipo_uso = tipoUso;
          return vehiculoParam;
        }
      }
      return undefined;
    },
    [
      anio,
      anioActualizado,
      combustible,
      marca,
      modelo,
      producto,
      submodelo,
      tipoUso
    ]
  );

  const configurarSucursales = useCallback(
    (planesParam) => {
      let listaSucursales = [];
      planesParam.forEach((item) => {
        if (
          item.sucursal?.id &&
          !listaSucursales.find((suc) => suc.id === item.sucursal.id)
        ) {
          listaSucursales.push(item.sucursal);
        }
      });
      listaSucursales = listaSucursales.sort((a, b) => a.id - b.id);
      if (user) {
        if (user.usuarioSegu.id_sucursal) {
          setSucursales(
            listaSucursales.filter(
              (item) => item.matriz || item.id === user.usuarioSegu.id_sucursal
            )
          );
          const sucursalEjecutivo = listaSucursales.find(
            (item) => item.id === user.usuarioSegu.id_sucursal
          );
          if (sucursalEjecutivo) {
            setSucursalSeleccionada(sucursalEjecutivo);
          } else {
            setSucursalSeleccionada(
              listaSucursales.find((item) => item.matriz)
            );
          }
        } else {
          setSucursales(listaSucursales);
          setSucursalSeleccionada(listaSucursales.find((item) => item.matriz));
        }
      }
    },
    [user]
  );

  const actualizarAutorizaciones = useCallback(
    async (cotizacionListParam) => {
      const planesEstandares = cotizacionListParam
        .flatMap((item) => item.planes)
        .filter((item) => item.id_plan);

      const planesEspecificos = cotizacionListParam
        .flatMap((item) => item.planes)
        .filter((item) => !item.id_plan);

      await verificarAutorizaciones(planesEstandares, planesEspecificos);
    },
    [verificarAutorizaciones]
  );

  const aplicaDescuentoPlanAbierto = useCallback(() => {
    // Si algun plan abierto aplica descuento a nivel plan y al menos una subcobertura a nivel subcobertura.

    let aplicaDescuento = false;
    for (let i = 0; i < planes.length; i += 1) {
      const plan = planes[i];
      if (!plan.producto_cerrado && plan.aplica_descuento) {
        for (let j = 0; j < plan.planSubcobertura.length; j += 1) {
          const planSub = plan.planSubcobertura[j];
          if (planSub.subcobertura.aplica_descuento) {
            aplicaDescuento = true;
            break;
          }
        }
      }
      if (aplicaDescuento) {
        break;
      }
    }
    return aplicaDescuento;
  }, [planes]);

  const aplicaDescuentoRecargo = useCallback(() => {
    // Si algun plan cerrado aplica descuento a nivel plan
    let planesReturn = planes.some((plan) => {
      return !!plan.aplica_descuento && plan.producto_cerrado;
    });
    if (!planesReturn) {
      // Si algun plan abierto aplica descuento a nivel plan y al menos una subcobertura a nivel subcobertura.
      planesReturn = aplicaDescuentoPlanAbierto();
    }
    if (
      statePassed.tipoCotizacion === 'masiva' &&
      (producto === 1 || producto === 5)
    ) {
      planesReturn = false;
    }
    return planesReturn;
  }, [planes, producto, statePassed, aplicaDescuentoPlanAbierto]);

  const tieneControlParaEstablecimiento = useCallback(() => {
    const controlesPorAutorizacion = autorizaciones.some((aut) =>
      aut.controles.some((item) => {
        return !!item.id_actividad && !item.eliminado;
      })
    );
    return controlesPorAutorizacion;
  }, [autorizaciones]);

  const tieneControlParaRubro = useCallback(() => {
    const controlesPorAutorizacion = autorizaciones.some((aut) =>
      aut.controles.some((item) => {
        return !!item.id_actividad_detalle && !item.eliminado;
      })
    );

    return controlesPorAutorizacion;
  }, [autorizaciones]);

  const isProductoListo = React.useCallback(
    ({
      departamento: departamentoParam,
      distrito,
      zona,
      domicilio,
      zonaHabilitada: zonaHabilitadaParam,
      actividad,
      establecimiento
    }) => {
      const formularioUbicacionCorrecto =
        (ubicacionMostrada && zonaHabilitadaParam && domicilio && zona) ||
        (ubicacionMostrada && !zonaHabilitadaParam) ||
        !ubicacionMostrada;
      let formularioZonaCorrecto;
      let ocultarFormActividadToMasiva;
      if (statePassed.tipoCotizacion === 'masiva') {
        formularioZonaCorrecto = true;
        ocultarFormActividadToMasiva = true;
      } else {
        formularioZonaCorrecto =
          ((departamentoMostrado === true && departamentoParam?.id) ||
            departamentoMostrado === false) &&
          ((distritoMostrado && distrito?.id) || !distritoMostrado) &&
          formularioUbicacionCorrecto;
      }

      let puedeRecargarPorActividad = true;

      // if (mostrarActividades) {
      //   puedeRecargarPorActividad = true;
      // }
      if (tieneControlParaEstablecimiento() && tieneControlParaRubro()) {
        puedeRecargarPorActividad =
          actividad?.length > 0 && establecimiento?.length > 0;
      } else if (tieneControlParaEstablecimiento()) {
        puedeRecargarPorActividad = establecimiento?.length > 0;
      } else if (tieneControlParaRubro()) {
        puedeRecargarPorActividad = actividad?.length > 0;
      }
      const formularioNoPatrimonial = producto !== 4 && producto !== 5;

      const formularioVehiculoCorrecto =
        producto === 1 &&
        marca &&
        modelo &&
        submodelo &&
        anio &&
        combustible &&
        tipoUso &&
        (representante === true ||
          (representante === false && volanteCambiado !== null)) &&
        (anioActualizado === false ||
          (anioActualizado === true && ceroKm !== null));
      const formularioOtrosCorrecto = producto !== 1;

      const productoListo =
        formularioZonaCorrecto &&
        (puedeRecargarPorActividad ||
          formularioNoPatrimonial ||
          ocultarFormActividadToMasiva) &&
        (formularioVehiculoCorrecto || formularioOtrosCorrecto);

      return productoListo;
    },
    [
      ubicacionMostrada,
      departamentoMostrado,
      distritoMostrado,
      producto,
      marca,
      modelo,
      submodelo,
      anio,
      combustible,
      tipoUso,
      representante,
      volanteCambiado,
      anioActualizado,
      ceroKm,
      tieneControlParaEstablecimiento,
      tieneControlParaRubro,
      statePassed.tipoCotizacion
    ]
  );

  const departamentoFormField = form.getFieldValue('departamento');
  const distritoFormField = form.getFieldValue('distrito')?.value;
  const zonaFormField = form.getFieldValue('zona');
  const domicilioField = form.getFieldValue('domicilio');
  const establecimientoField = form.getFieldValue('tipo_establecimiento');
  const actividadField = form.getFieldValue('rubro');

  const formularioListo = isProductoListo({
    vehiculo,
    reajuste,
    ...(vigencia || {}),
    ...(departamentoFormField
      ? { departamento: { id: departamentoFormField } }
      : {}),
    ...(distritoFormField ? { distrito: { id: distritoFormField } } : {}),
    ...(zonaFormField ? { zona: zonaFormField } : {}),
    ...(domicilioField ? { domicilio: domicilioField } : {}),
    zonaHabilitada,
    ...(actividadField ? { actividad: actividadField } : {}),
    ...(establecimientoField ? { establecimiento: establecimientoField } : {})
  });

  const puedeMostrarPlanes =
    vigencia && formularioListo && !loadingGeneral && !debouncingPlanes;

  const getPlanesCore = React.useCallback(
    async (cotizacionParams) => {
      try {
        if (empresa && producto && user) {
          const cotizacionParamsFinal = { ...cotizacionParams };
          if (
            !cotizacionParams.desde ||
            !cotizacionParams.hasta ||
            !cotizacionParams.cantidad_dias
          ) {
            return;
          }
          cotizacionParamsFinal.vehiculo = getVehiculo(cotizacionParamsFinal);
          setLoadingGeneral(true);
          setDebouncingPlanes(false);
          const responseList = await instanceRef.instance.post(
            `/plan/asignados/empresa/cotizacionamedida`,
            {
              empresaId: empresa.id,
              productoId: producto,
              tipoVenta,
              ...cotizacionParamsFinal
            }
          );
          setSubcoberturasParaExcluir(
            responseList.data.data.subcoberturasParaExcluir
          );
          setControlFranquicias(responseList.data.data.controlFranquicias);
          const planesCotizacion = responseList.data.data.planesCalculados;
          setPlanes(planesCotizacion);
          configurarSucursales(planesCotizacion);
          const monedasConfiguradas = configurarMonedas(planesCotizacion);
          const cotizacionList = responseList.data.data.cotizaciones;
          setCotizaciones(cotizacionList);
          const {
            selectedIndexsEstNuevos,
            selectedIndexsEspNuevos
          } = recalcularIndicesSeleccionados(
            cotizaciones,
            cotizacionList,
            Object.keys(monedasConfiguradas)
          );

          // Se actualiza lista de planes selecionados, en caso de que aparezcan
          // nuevos planes o dejen de aparecer debido a los controles
          setSelectedIndexsEst(selectedIndexsEstNuevos);
          setSelectedIndexsEsp(selectedIndexsEspNuevos);
          updateSelectedPlanes(
            selectedIndexsEstNuevos,
            selectedIndexsEspNuevos,
            cotizacionList
          );
          await actualizarAutorizaciones(cotizacionList);
          setLoadedPlanes(true);
        }
        setLoadedPlanes(true);
      } catch (err) {
        errorHandler(err);
        setLoadedPlanes(true);
        setDebouncingPlanes(false);
      }
    },
    [
      empresa,
      producto,
      user,
      getVehiculo,
      tipoVenta,
      configurarSucursales,
      configurarMonedas,
      recalcularIndicesSeleccionados,
      cotizaciones,
      updateSelectedPlanes,
      actualizarAutorizaciones
    ]
  );

  const getPlanes = React.useMemo(() => {
    return debounce(getPlanesCore, 1000);
  }, [getPlanesCore]);

  const getPlanesListo = React.useCallback(
    (params) => {
      const lis = isProductoListo(params);
      if (lis || !loadedPlanes) {
        setDebouncingPlanes(true);
        getPlanes(params);
      }
    },
    [getPlanes, isProductoListo, loadedPlanes]
  );

  const getVigenciaSugeridaAndConfig = React.useCallback(
    async (empresaParam, productoParam) => {
      const response = await instanceRef.instance.get(
        `/cotizacion/vigencia-sugerida-config`,
        {
          params: {
            idEmpresa: empresaParam.id,
            idProducto: productoParam
          }
        }
      );

      const vigenciaResponse = response.data?.data || {};
      const { desde, hasta, cantidadDias } = vigenciaResponse.vigenciaSugerida;
      await getPlanesCore({ cantidad_dias: cantidadDias, desde, hasta });

      setVigenciaSugeridaConfig(response.data?.data);
      setLoadedVigenciaSugerida(true);
      // setLoadingVigencias(false);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const onChangePlanSelector = (
    idCotizacion,
    tipo,
    columna,
    monedaSelected,
    idComision
  ) => {
    const selectedIndexsEspNuevo = { ...selectedIndexsEsp };
    const selectedIndexsEstNuevo = { ...selectedIndexsEst };
    if (tipo === 'especifico') {
      const cotizacion = selectedIndexsEspNuevo[idCotizacion];
      if (!cotizacion) {
        selectedIndexsEspNuevo[idCotizacion] = {
          [monedaSelected.codigo]: [[idComision, columna]]
        };
      } else if (!cotizacion[monedaSelected.codigo]) {
        // Si ya existen planes para esta moneda
        selectedIndexsEspNuevo[idCotizacion][monedaSelected.codigo] = [
          [idComision, columna]
        ];
      } else {
        const cotizacionMoneda = cotizacion[monedaSelected.codigo];
        const existePlanEsp = cotizacionMoneda.find(
          (item) => item[1] === columna && item[0] === idComision
        );
        if (existePlanEsp || existePlanEsp === 0) {
          const selectedIndexs =
            selectedIndexsEspNuevo[idCotizacion][monedaSelected.codigo];
          // El segundo valor de cada elemento son las columnas seleccionadas.

          // Se deselecciona el plan
          const columnasFiltradas = selectedIndexs.filter(
            (item) => item[1] !== columna || item[0] !== idComision
          );

          selectedIndexsEspNuevo[idCotizacion][
            monedaSelected.codigo
          ] = columnasFiltradas;
        } else {
          // Se selecciona el plan
          selectedIndexsEspNuevo[idCotizacion][monedaSelected.codigo] = [
            ...selectedIndexsEspNuevo[idCotizacion][monedaSelected.codigo],
            [idComision, columna]
          ];
        }
      }
      setSelectedIndexsEsp(selectedIndexsEspNuevo);
    } else if (tipo === 'estandar') {
      const cotizacion = selectedIndexsEstNuevo[idCotizacion];
      if (!cotizacion) {
        selectedIndexsEstNuevo[idCotizacion] = {
          [monedaSelected.codigo]: [[idComision, columna]]
        };
      } else if (!cotizacion[monedaSelected.codigo]) {
        // Si ya existen planes para esta moneda
        selectedIndexsEstNuevo[idCotizacion][monedaSelected.codigo] = [
          [idComision, columna]
        ];
      } else {
        const cotizacionMoneda = cotizacion[monedaSelected.codigo];
        const existePlanEst = cotizacionMoneda.find(
          (item) => item[1] === columna && item[0] === idComision
        );
        if (existePlanEst || existePlanEst === 0) {
          // Se deselecciona el plan

          selectedIndexsEstNuevo[idCotizacion][
            monedaSelected.codigo
          ] = selectedIndexsEstNuevo[idCotizacion][
            monedaSelected.codigo
          ].filter((item) => item[1] !== columna || item[0] !== idComision);
        } else {
          // Se selecciona el plan
          selectedIndexsEstNuevo[idCotizacion][monedaSelected.codigo] = [
            ...selectedIndexsEstNuevo[idCotizacion][monedaSelected.codigo],
            [idComision, columna]
          ];
        }
      }
      setSelectedIndexsEst(selectedIndexsEstNuevo);
    }
    updateSelectedPlanes(
      selectedIndexsEstNuevo,
      selectedIndexsEspNuevo,
      filterSucursal(cotizaciones)
    );
  };

  function goBack() {
    if (current === 2 && !mostrarPasoEdicion) {
      setCurrent(0);
    } else {
      setCurrent(current - 1);
    }
  }

  const existePlan = (asegu) => {
    let existe = false;
    for (let i = 0; i < monedaSelectedList.length; i += 1) {
      const monedaSelected = monedaSelectedList[i];
      const sinEstandar = !selectedPlanesEst.find(
        (item) =>
          item.aseguradoraProducto.id_aseguradora === asegu.id &&
          item.id_moneda === monedaSelected.id
      );
      const sinEspecifico = !selectedPlanesEsp.find(
        (item) =>
          item.aseguradoraProducto.id_aseguradora === asegu.id &&
          item.id_moneda === monedaSelected.id
      );
      if (sinEstandar && sinEspecifico) {
        existe = false;
      } else {
        existe = true;
        break;
      }
    }

    return existe;
  };

  const { data: departamentos } = useQuery({
    queryKey: ['departamentos'],
    queryFn: departamentosFetcher,
    staleTime: Infinity
  });

  const { data: distritos, isLoading: loadingDistritos } = useQuery({
    queryKey: ['distritos', departamento],
    queryFn: () => distritosFetcher(departamento),
    staleTime: Infinity
  });

  const debounceDireccionChange = debounce(async () => {
    geocalizarMap();
  }, 1000);

  const geocalizarMap = async () => {
    const departamentoForm = form.getFieldValue('departamento');
    const distrito = form.getFieldValue('distrito')?.value;
    const domicilio = form.getFieldValue('domicilio') || '';

    const departamentoDesc = departamentoForm
      ? departamentos.find((item) => item.id === departamentoForm)?.descripcion
      : '';

    const distritoDesc = distrito
      ? distritos.find((item) => item.id === distrito)?.descripcion
      : '';

    const direccionConcat = `${departamentoDesc}, ${distritoDesc}, ${domicilio}`;

    const coordenadasEncontrada = await getCoordenadasByDireccion(
      direccionConcat
    );

    if (domicilio.length > 0) {
      setZoomMap(15);
    }

    if (coordenadasEncontrada) {
      form.setFieldsValue({ zona: coordenadasEncontrada });
      onDomicilioChange(domicilio, coordenadasEncontrada);
      setMarker(false);
    } else {
      onDomicilioChange(domicilio);
    }
  };

  const onChangeDistrito = (val) => {
    verificarDistrito(val.value);
  };

  const verificarDistrito = async (value) => {
    const autorizacionDistrito = autorizaciones.some((item) =>
      item.configs.some((config) => {
        if (
          config.tipo_validacion === 'ZONA' &&
          config.cP &&
          config.cP.length > 0
        ) {
          return config.cP.some(
            (control) =>
              control.id_distrito === Number(value) && !control.eliminado
          );
        }
        return false;
      })
    );
    if (!autorizacionDistrito) {
      setWarningDistrito();
    }
    const departamentoForm = form.getFieldValue('departamento');
    const zona = form.getFieldValue('zona');
    const domicilio = form.getFieldValue('domicilio');
    const establecimiento = form.getFieldValue('tipo_establecimiento');
    const actividad = form.getFieldValue('rubro');

    getPlanesListo({
      vehiculo,
      reajuste,
      ...(vigencia || {}),
      ...(departamentoForm ? { departamento: { id: departamentoForm } } : {}),
      distrito: { id: value },
      ...(zona ? { zona } : {}),
      ...(domicilio ? { domicilio } : {}),
      reload: false,
      zonaHabilitada,
      ...(actividad ? { actividad } : {}),
      ...(establecimiento ? { establecimiento } : {})
    });
  };
  const onChangeActividad = (value) => {
    const departamentoForm = form.getFieldValue('departamento');
    const zona = form.getFieldValue('zona');
    const domicilio = form.getFieldValue('domicilio');
    const establecimiento = value;
    const actividad = form.getFieldValue('rubro');
    const distrito = form.getFieldValue('distrito')?.value;

    let puedeRecargarPorActividad = false;
    if (tieneControlParaEstablecimiento() && tieneControlParaRubro()) {
      puedeRecargarPorActividad =
        actividad?.length > 0 && establecimiento?.length > 0;
    } else if (tieneControlParaEstablecimiento()) {
      puedeRecargarPorActividad = establecimiento?.length > 0;
    } else if (tieneControlParaRubro()) {
      puedeRecargarPorActividad = actividad?.length > 0;
    }
    if (puedeRecargarPorActividad) {
      getPlanesListo({
        vehiculo,
        reajuste,
        ...(vigencia || {}),
        ...(departamentoForm ? { departamento: { id: departamentoForm } } : {}),
        ...(distrito ? { distrito: { id: distrito } } : {}),
        ...(zona ? { zona } : {}),
        ...(domicilio ? { domicilio } : {}),
        reload: false,
        zonaHabilitada,
        establecimiento,
        actividad
      });
    }
  };
  const onChangeRubro = (value) => {
    const departamentoForm = form.getFieldValue('departamento');
    const zona = form.getFieldValue('zona');
    const domicilio = form.getFieldValue('domicilio');
    const establecimiento = form.getFieldValue('tipo_establecimiento');
    const actividad = value;
    const distrito = form.getFieldValue('distrito')?.value;

    let puedeRecargarPorActividad = false;
    if (tieneControlParaEstablecimiento() && tieneControlParaRubro()) {
      puedeRecargarPorActividad =
        actividad?.length > 0 && establecimiento?.length > 0;
    } else if (tieneControlParaEstablecimiento()) {
      puedeRecargarPorActividad = establecimiento?.length > 0;
    } else if (tieneControlParaRubro()) {
      puedeRecargarPorActividad = actividad?.length > 0;
    }
    if (puedeRecargarPorActividad) {
      getPlanesListo({
        vehiculo,
        reajuste,
        ...(vigencia || {}),
        ...(departamentoForm ? { departamento: { id: departamentoForm } } : {}),
        ...(distrito ? { distrito: { id: distrito } } : {}),
        ...(zona ? { zona } : {}),
        ...(domicilio ? { domicilio } : {}),
        reload: false,
        zonaHabilitada,
        establecimiento,
        actividad
      });
    }
  };
  const verificarDepartamento = async (value) => {
    const autorizacionDepartamento = autorizaciones.some((item) =>
      item.configs.some((config) => {
        if (
          config.tipo_validacion === 'ZONA' &&
          config.cP &&
          config.cP.length > 0
        ) {
          return config.cP.some(
            (control) =>
              control.id_departamento === Number(value) && !control.eliminado
          );
        }
        return false;
      })
    );
    if (!autorizacionDepartamento) {
      setWarningDepartamento();
    }

    const distrito = form.getFieldValue('distrito')?.value;
    const zona = form.getFieldValue('zona');
    const establecimiento = form.getFieldValue('tipo_establecimiento');
    const actividad = form.getFieldValue('rubro');

    if (!distritoMostrado && !ubicacionMostrada) {
      getPlanesListo({
        vehiculo,
        reajuste,
        ...(vigencia || {}),
        departamento: { id: value },
        ...(distrito ? { distrito: { id: distrito } } : {}),
        ...(zona ? { zona } : {}),
        zonaHabilitada,
        ...(actividad ? { actividad } : {}),
        ...(establecimiento ? { establecimiento } : {})
      });
    }
  };

  const onChangeDepartamento = (value) => {
    setDepartamento(value);
    verificarDepartamento(value);
    const asuncion =
      value && departamentos.find((item) => item.id === value)?.codigo === 0;

    if (asuncion) {
      form.setFieldsValue({
        distrito: {
          value: '169',
          label: 'ASUNCION'
        }
      });
      verificarDistrito('169');
    } else {
      form.setFieldsValue({
        distrito: null
      });
      setWarningDistrito();
    }
  };

  const tieneAutorizacionPorTipo = useCallback(
    (tipo) => {
      const controlesPorAutorizacion = autorizaciones.some((item) =>
        item.configs.some((config) => {
          if (tipo === 'ZONA') {
            if (
              config.tipo_validacion === tipo &&
              config.cP &&
              config.cP.length > 0
            ) {
              const controlDepartamento = config.cP.some(
                (control) => control.id_departamento && !control.eliminado
              );
              const controlDistrito = config.cP.some(
                (control) => control.id_distrito && !control.eliminado
              );
              const controlPoligono = config.cP.some(
                (control) => control.poligono && !control.eliminado
              );
              return (
                controlDepartamento ||
                controlDistrito ||
                (controlPoligono &&
                  (Number(producto) === 4 ||
                    Number(producto) === 5 ||
                    Number(producto) === 6))
              );
            }
            return false;
          }
          if (tipo === 'VEHICULO') {
            return (
              config.tipo_validacion === tipo &&
              config.cP &&
              config.cP.length > 0
            );
          }
          if (tipo === 'ACTIVIDAD') {
            if (
              config.tipo_validacion === tipo &&
              config.cPA &&
              config.cPA.length > 0
            ) {
              const controlEstablecimiento = config.cPA.some(
                (control) => control.id_actividad && !control.eliminado
              );
              const controlRubro = config.cPA.some(
                (control) => control.id_actividad_detalle && !control.eliminado
              );
              return controlEstablecimiento || controlRubro;
            }
            return false;
          }
          return config.tipo_validacion === tipo;
        })
      );
      return controlesPorAutorizacion;
    },
    [autorizaciones, producto]
  );

  /**
   *
   * @returns
   */
  const tienePlanControlProductoZona = () => {
    let controlesPorPlan = false;
    if (planes) {
      controlesPorPlan = planes.some(
        (item) =>
          item.controles?.length > 0 &&
          item.controles.some(
            (control) =>
              control.eliminado !== true &&
              getTipoValidacion(control) === 'zona'
          )
      );
    }
    return controlesPorPlan;
  };

  const onReajusteChange = (value) => {
    const departamentoForm = form.getFieldValue('departamento');
    const distrito = form.getFieldValue('distrito')?.value;
    const zona = form.getFieldValue('zona');
    const establecimiento = form.getFieldValue('tipo_establecimiento');
    const actividad = form.getFieldValue('rubro');
    getPlanesListo({
      vehiculo,
      reajuste: value,
      ...(vigencia || {}),
      ...(departamentoForm ? { departamento: { id: departamentoForm } } : {}),
      ...(distrito ? { distrito: { id: distrito } } : {}),
      ...(zona ? { zona } : {}),
      ...(actividad ? { actividad } : {}),
      ...(establecimiento ? { establecimiento } : {}),
      zonaHabilitada
    });
  };

  const onMontoChange = (value) => {
    setVehiculo((vehiculoActual) => ({
      ...vehiculoActual,
      sumaAsegurada: value
    }));
  };

  const { data: marcas } = useQuery({
    queryKey: ['marcas'],
    queryFn: marcasFetcher,
    staleTime: Infinity
  });

  const { data: modelos, isLoading: loadingModelos } = useQuery({
    queryKey: ['modelos', marca],
    queryFn: () => modelosFetcher(marca),
    staleTime: Infinity
  });

  const { data: anios, isLoading: loadingAnios } = useQuery({
    queryKey: ['anios', marca, modelo],
    queryFn: () => aniosFetcher(marca, modelo),
    staleTime: Infinity
  });

  const { data: submodelos, isLoading: loadingSubmodelos } = useQuery({
    queryKey: ['submodelos', marca, modelo, anio],
    queryFn: () => submodelosFetcher(marca, modelo, anio),
    staleTime: Infinity
  });

  const verificarDatos = () => {
    form.validateFields();
    if (
      marca &&
      modelo &&
      submodelo &&
      anio &&
      combustible &&
      tipoUso &&
      (representante === true ||
        (representante === false && volanteCambiado !== null)) &&
      (anioActualizado === false ||
        (anioActualizado === true && ceroKm !== null))
    ) {
      return true;
    }
    return false;
  };

  const onClick = (coordenadas) => {
    form.setFieldsValue({ zona: coordenadas });
    const departamentoForm = form.getFieldValue('departamento');
    const distrito = form.getFieldValue('distrito')?.value;
    const domicilio = form.getFieldValue('domicilio');
    const establecimiento = form.getFieldValue('tipo_establecimiento');
    const actividad = form.getFieldValue('rubro');

    getPlanesListo({
      vehiculo,
      reajuste,
      ...(vigencia || {}),
      ...(departamentoForm ? { departamento: { id: departamentoForm } } : {}),
      ...(distrito ? { distrito: { id: distrito } } : {}),
      zona: coordenadas,
      ...(domicilio ? { domicilio } : {}),
      ...(actividad ? { actividad } : {}),
      ...(establecimiento ? { establecimiento } : {}),
      zonaHabilitada
    });

    setMarker(true);
  };

  const onChangeMoneda = (checkedValues) => {
    const monedasSelected = checkedValues.map(
      (codigo) => monedas.filter((mon) => mon.codigo === codigo)[0]
    );
    setMonedaSelectedList(monedasSelected);

    const selectedIndexsEspNuevo = { ...selectedIndexsEsp };
    Object.keys(selectedIndexsEspNuevo).forEach((cotizacion) => {
      Object.keys(selectedIndexsEspNuevo[cotizacion]).forEach(
        (codigoMoneda) => {
          if (
            !monedasSelected.map((item) => item.codigo).includes(codigoMoneda)
          ) {
            selectedIndexsEspNuevo[cotizacion][codigoMoneda] = [];
          }
        }
      );
    });
    setSelectedIndexsEsp(selectedIndexsEspNuevo);

    const selectedIndexsEstNuevo = { ...selectedIndexsEst };
    Object.keys(selectedIndexsEstNuevo).forEach((cotizacion) => {
      Object.keys(selectedIndexsEstNuevo[cotizacion]).forEach(
        (codigoMoneda) => {
          if (
            !monedasSelected.map((item) => item.codigo).includes(codigoMoneda)
          ) {
            selectedIndexsEstNuevo[cotizacion][codigoMoneda] = [];
          }
        }
      );
    });
    setSelectedIndexsEst(selectedIndexsEstNuevo);
    updateSelectedPlanes(
      selectedIndexsEstNuevo,
      selectedIndexsEspNuevo,
      cotizaciones
    );
  };

  const zonaFormProps = {
    producto,
    departamentoMostrado,
    warningDepartamento,
    onChangeDepartamento,
    departamentos,
    onChangeDistrito,
    distritoMostrado,
    warningDistrito,
    loadingDistritos,
    distritos,
    ubicacionMostrada,
    zonaHabilitada,
    onZonaHabilitadaChange,
    debounceDireccionChange,
    zoomMap,
    zonas,
    marker,
    onClick,
    tieneAutorizacionZonaPorTipo,
    autorizaciones,
    zonasEmpresa,
    empresa,
    zonasAseguradoras,
    aseguradoras
  };

  const onChangeDescuentoRecargo = () => {
    let reajusteNuevo = 0;
    const descuento = form.getFieldValue('descuento');
    const tieneDescuentoRecargo = form.getFieldValue('tieneDescuentoRecargo');
    if (descuento && tieneDescuentoRecargo) {
      const descuentoNumero = form.getFieldValue('descuento').number;
      const descuentoTipo = form.getFieldValue('descuento').tipo;

      const signo = descuentoTipo === 'descuento' ? -1 : 1;
      reajusteNuevo = Number(descuentoNumero) * signo || 0;
    }
    setReajuste(reajusteNuevo);
    onReajusteChange(reajusteNuevo);
  };

  const handleOpenUrl = (url) => {
    history.push(url);
  };

  const getActividadDetalle = async () => {
    try {
      const response = await instanceRef.instance.get('/actividaddetalle');
      const actividadDetalleList = response.data.data;
      setActividadDetalles(
        actividadDetalleList.map((e) => ({
          value: e.id,
          label: e.detalle
        }))
      );
      return actividadDetalleList.map((e) => ({
        value: e.id,
        label: e.detalle
      }));
    } catch (e) {
      message.error(e.message);
      return null;
    }
  };

  const getActividad = async () => {
    try {
      const response = await instanceRef.instance.get('/actividad');
      const actividadList = response.data.data;
      setActividades(
        actividadList.map((e) => ({
          value: e.id,
          label: e.grupo
        }))
      );
      return actividadList;
    } catch (e) {
      message.error(e.message);
      return null;
    }
  };

  const getComisionesAseguradora = async () => {
    try {
      const response = await instanceRef.instance.get(
        '/comisionaseguradora/all'
      );
      const comisionesList = response.data.data;
      setComisionesAseguradora(comisionesList);
      return comisionesList;
    } catch (e) {
      message.error(e.message);
      return null;
    }
  };

  const tieneComision = (comision, planesToFilterComision) => {
    return (
      planesToFilterComision.filter(
        (e) => e.comisionAseguradora.id === comision.id
      ).length > 0
    );
  };

  const fetchComisionAseguradoraEmpresaProducto = async () => {
    try {
      const response = await instanceRef.instance.get(
        `/comisionaseguradoraempresaproducto/all`
      );
      if (response.data?.data) {
        const comisiones = response.data?.data;
        setComisionesAEP(comisiones);
      }
    } catch (error) {
      errorHandler(
        error,
        'No se pudo obtener las comisiones de la Aseguradora Empresa Producto'
      );
      setLoading(false);
    }
  };

  useEffect(() => {
    const existeAlerta = validacionByAseguradoraList.find(
      (item) => item.mostrarAlerta === true
    );
    setMostrarValidaciones(existeAlerta);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vigenciaByAseguradoraList, validacionByAseguradoraList]);

  useEffect(() => {
    if (ceroKm !== null) {
      setVehiculo((vehiculoActual) => ({
        ...vehiculoActual,
        ceroKm
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ceroKm]);

  useEffect(() => {
    if (representante !== null) {
      setVehiculo((vehiculoActual) => ({ ...vehiculoActual, representante }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [representante]);

  useEffect(() => {
    if (volanteCambiado !== null) {
      setVehiculo({ ...vehiculo, volante_cambiado: volanteCambiado });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [volanteCambiado]);

  useEffect(() => {
    if (combustible !== null) {
      setVehiculo({ ...vehiculo, combustible });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [combustible]);

  useEffect(() => {
    if (tipoUso !== null) {
      setVehiculo({ ...vehiculo, tipo_uso: tipoUso });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tipoUso]);

  useEffect(() => {
    if (submodelo) {
      setVehiculo((vehiculoActual) => ({
        ...vehiculoActual,
        submodelo: submodelos.find((item) => item.id === submodelo)
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submodelo]);

  useEffect(() => {
    if (vehiculo) {
      if (Object.keys(vehiculo).length > 0) {
        if (vehiculo.sumaAsegurada) {
          const departamentoForm = form.getFieldValue('departamento');
          const distrito = form.getFieldValue('distrito')?.value;
          const zona = form.getFieldValue('zona');
          const establecimiento = form.getFieldValue('tipo_establecimiento');
          const actividad = form.getFieldValue('rubro');
          getPlanesListo({
            vehiculo,
            reajuste,
            ...(vigencia || {}),
            ...(departamentoForm
              ? { departamento: { id: departamentoForm } }
              : {}),
            ...(distrito ? { distrito: { id: distrito } } : {}),
            ...(zona ? { zona } : {}),
            ...(actividad ? { actividad } : {}),
            ...(establecimiento ? { establecimiento } : {}),
            zonaHabilitada
          });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehiculo]);

  useEffect(() => {
    if (planes && planes.length > 0 && producto) {
      const newaseguradoras = [];
      const auxaseguradoras = Array.from(
        new Set(planes.map((item) => item.aseguradoraProducto.id_aseguradora))
      );
      for (let i = 0; i < auxaseguradoras.length; i += 1) {
        for (let j = 0; j < planes.length; j += 1) {
          if (
            auxaseguradoras[i] === planes[j].aseguradoraProducto.id_aseguradora
          ) {
            newaseguradoras.push({
              id: planes[j].aseguradoraProducto.id_aseguradora,
              codigo:
                planes[j].aseguradoraEmpresaProducto.aseguradoraEmpresa
                  .aseguradora.codig,
              nombre:
                planes[j].aseguradoraEmpresaProducto.aseguradoraEmpresa
                  .aseguradora.nombr
            });
            j = planes.length;
          }
        }
      }

      setAseguradoras(newaseguradoras);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planes]);

  useEffect(() => {
    if (empresa && producto && !loadingInicial) {
      getVigenciaSugeridaAndConfig(empresa, producto);
    }
  }, [empresa, getVigenciaSugeridaAndConfig, producto, loadingInicial]);

  useEffect(() => {
    const actual = getProductoActual().descripcion;
    if (actual) {
      setProductoActual(actual);
    }
  }, [getProductoActual]);

  useEffect(() => {
    if (productoActual && loadedVigenciaSugerida && loadedPlanes) {
      setLoadingInicial(true);
    }
  }, [productoActual, loadedVigenciaSugerida, loadedPlanes]);

  useEffect(() => {
    if (!producto) {
      if (statePassed.tipoCotizacion !== 'masiva') {
        history.push(`/crearcotizacion`);
      } else {
        history.push(`/crearcotizacionmasiva`);
      }
    } else if (producto) {
      if (
        statePassed.tipoCotizacion === 'masiva' &&
        producto !== 1 &&
        producto !== 5
      ) {
        setVisibleSectorPlanes(true);
      } else if (statePassed.tipoCotizacion !== 'masiva') {
        setVisibleSectorPlanes(true);
      }
    }
  }, [history, producto, statePassed.tipoCotizacion]);

  useEffect(() => {
    if (solicitado && !empresa.tiene_sms) {
      history.push(`/solicitar/${tokenGenerado}`);
    }
  }, [tokenGenerado, solicitado, empresa, history]);

  useEffect(() => {
    getActividad();
    getActividadDetalle();
  }, []);

  useEffect(() => {
    getComisionesAseguradora();
    fetchComisionAseguradoraEmpresaProducto();
  }, []);

  const tienePlanAbierto = (planesSelecionados) =>
    planesSelecionados.length > 0 &&
    planesSelecionados.some((plan) => !plan.producto_cerrado);

  const handleNextStepClick = async () => {
    if (await validateStep(current)) {
      const esEditable =
        tienePlanAbierto(selectedPlanesEsp) ||
        tienePlanAbierto(selectedPlanesEst);

      setmostrarPasoEdicion(esEditable);

      let nextStep;
      if (current === 0) {
        nextStep = esEditable ? current + 1 : current + 2;
      } else if (current === 1) {
        nextStep = current + 1;
      }

      setCurrent(nextStep);
      setTimeout(() => scrollTop());
    }
  };

  const getFilteredCotizaciones = () => {
    if (tipoVenta === 'telefonica') {
      return filterSucursal(cotizaciones).filter(
        (item) => item.aseguradoraEmpresaProducto.venta_telefonica
      );
    }
    if (tipoVenta === 'presencial') {
      return filterSucursal(cotizaciones).filter(
        (item) => item.aseguradoraEmpresaProducto.venta_presencial
      );
    }
    return filterSucursal(cotizaciones);
  };
  const mostrarRadioButtonVentaTelefonica =
    empresa?.tiene_telefonica &&
    productosTelefonicos.find((item) => item.id === producto);
  const mostrarRadioButtonPresencial =
    empresa?.tiene_presencial &&
    productosPresenciales.find((item) => item.id === producto);

  function getTitle() {
    if (statePassed.tipoCotizacion === 'masiva') {
      return <Title>{`Cotización masiva a medida de ${productoActual}`}</Title>;
    }
    return <Title>{`Cotización a medida de ${productoActual}`}</Title>;
  }

  const verificarComisionUnica = (p) => {
    for (const asegu of aseguradoras) {
      const planesAsegu = p.filter(
        (item) => item.aseguradoraProducto.id_aseguradora === asegu.id
      );
      const comisionUnica = planesAsegu[0].comisionAseguradora.valor;
      // Iteramos sobre cada plan de la cotización
      for (const plan of planesAsegu) {
        // eslint-disable-next-line no-lonely-if
        if (plan.comisionAseguradora.valor !== comisionUnica) {
          return false;
        }
      }
    }

    // Si no encontramos ninguna diferencia, retornamos true
    return true;
  };

  return (
    <ResponsiveContainer style={{ maxWidth: maxWidthHoja }}>
      <Card style={{ borderRadius: 4 }}>
        <Spin spinning={!loadingInicial} tip="Preparando cotización">
          {!loadingInicial && <div style={{ height: 100 }} />}
        </Spin>
        <div ref={myRef} />
        {loadingInicial && (
          <>
            {getTitle()}
            {!solicitado && (
              <div>
                <StepperSolicitud current={current} steps={steps.slice(0, 6)} />

                {current === steps.length - 1 && (
                  <div>
                    <br />
                    <Title>{!solicitado && steps[current].description}</Title>
                  </div>
                )}
                {current !== steps.length - 1 && (
                  <div>
                    <br />
                    <Title>{steps[current].description}</Title>
                  </div>
                )}
                <Form
                  // {...formItemLayout}
                  scrollToFirstError
                  form={form}
                  autoComplete="off"
                  layout="vertical"
                >
                  <Spin
                    spinning={loadingGeneral}
                    size="large"
                    tip="Cargando datos..."
                    style={{
                      position: 'fixed',
                      left: marginLeft,
                      right: 0,
                      transform: `translate(calc(50vw - 50%), calc(50vh - 50%))`
                    }}
                  >
                    <div
                      style={{
                        maxWidth,
                        margin: 'auto',
                        marginLeft: marginLeftPrincipal,
                        marginRight: marginRightPrincipal
                      }}
                    >
                      {/* Datos del vehiculo */}
                      {current === 0 &&
                        !solicitado &&
                        producto === 1 &&
                        statePassed.tipoCotizacion !== 'masiva' && (
                          <div
                            style={{
                              textAlign: 'left'
                            }}
                          >
                            <>
                              <Subtitle>Datos del vehículo</Subtitle>
                              <Card
                              // style={{ textAlign: 'left', boxShadow: 'none' }}
                              // bodyStyle={{ padding: 0 }}
                              // bordered={false}
                              >
                                <>
                                  <Row
                                    gutter={[16, 0]}
                                    style={{ textAlign: 'start' }}
                                  >
                                    <Col xs={24} md={12}>
                                      <Form.Item
                                        label="Marca"
                                        name="marca"
                                        rules={[
                                          {
                                            required: true,
                                            message: 'Debe indicar la Marca'
                                          }
                                        ]}
                                      >
                                        <Select
                                          showSearch
                                          filterOption={(input, option) =>
                                            option.children
                                              .toLowerCase()
                                              .indexOf(input.toLowerCase()) >= 0
                                          }
                                          style={{ width: '100%' }}
                                          optionFilterProp="children"
                                          placeholder="Elegir marca"
                                          value={marca}
                                          onChange={(value) => {
                                            setMarca(value);
                                            setModelo(null);
                                            setSubmodelo(null);
                                            setAnio(null);
                                            cleanMontos();
                                            form.setFieldsValue({
                                              modelo: null,
                                              submodelo: null,
                                              anio: null
                                            });
                                          }}
                                        >
                                          {marcas?.map((item) => (
                                            <Option
                                              key={item.id}
                                              value={item.id}
                                            >
                                              {item.descripcion}
                                            </Option>
                                          ))}
                                        </Select>
                                      </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                      <Form.Item
                                        label="Modelo"
                                        name="modelo"
                                        rules={[
                                          {
                                            required: true,
                                            message: 'Debe indicar el Modelo'
                                          }
                                        ]}
                                      >
                                        <Select
                                          showSearch
                                          loading={loadingModelos}
                                          notFoundContent={
                                            <NotFoundContentLoading
                                              loading={loadingModelos}
                                            />
                                          }
                                          filterOption={(input, option) =>
                                            option.children
                                              .toLowerCase()
                                              .indexOf(input.toLowerCase()) >= 0
                                          }
                                          style={{ width: '100%' }}
                                          placeholder="Elegir modelo"
                                          value={modelo}
                                          onChange={(value) => {
                                            setModelo(value);
                                            setSubmodelo(null);
                                            setAnio(null);
                                            cleanMontos();
                                            form.setFieldsValue({
                                              submodelo: null,
                                              anio: null
                                            });
                                          }}
                                        >
                                          {modelos?.map((item) => (
                                            <Option
                                              key={item.id}
                                              value={item.id}
                                            >
                                              {item.descripcion}
                                            </Option>
                                          ))}
                                        </Select>
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                  {screens.md && <br />}
                                  <Row
                                    gutter={[16, 0]}
                                    style={{ textAlign: 'start' }}
                                  >
                                    <Col xs={24} md={12}>
                                      <Form.Item
                                        label="Año"
                                        name="anio"
                                        rules={[
                                          {
                                            required: true,
                                            message: 'Debe indicar el Año'
                                          }
                                        ]}
                                      >
                                        <Select
                                          showSearch
                                          loading={loadingAnios}
                                          notFoundContent={
                                            <NotFoundContentLoading
                                              loading={loadingAnios}
                                            />
                                          }
                                          filterOption={(input, option) =>
                                            option.children
                                              .toLowerCase()
                                              .indexOf(input.toLowerCase()) >= 0
                                          }
                                          style={{ width: '100%' }}
                                          placeholder="Elegir año"
                                          value={anio}
                                          onChange={(value) => {
                                            setAnio(value);
                                            cleanMontos();
                                            setSubmodelo(null);
                                            form.setFieldsValue({
                                              submodelo: null
                                            });
                                            verificarCombustible();
                                          }}
                                        >
                                          {anios?.map((item) => (
                                            <Option
                                              key={item.descripcion}
                                              value={item.descripcion}
                                            >
                                              {item.descripcion}
                                            </Option>
                                          ))}
                                        </Select>
                                      </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                      <Form.Item
                                        label="Submodelo"
                                        name="submodelo"
                                        rules={[
                                          {
                                            required: true,
                                            message: 'Debe indicar el Submodelo'
                                          }
                                        ]}
                                      >
                                        <Select
                                          showSearch
                                          loading={loadingSubmodelos}
                                          notFoundContent={
                                            <NotFoundContentLoading
                                              loading={loadingSubmodelos}
                                            />
                                          }
                                          filterOption={(input, option) =>
                                            option.children
                                              .toLowerCase()
                                              .indexOf(input.toLowerCase()) >= 0
                                          }
                                          style={{ width: '100%' }}
                                          placeholder="Elegir submodelo"
                                          value={submodelo}
                                          onChange={(value) => {
                                            setSubmodelo(value);
                                            verificarCombustible(value);
                                            updateMontoFromSubmodelo(value);
                                            mostrarVehiculoCero({
                                              value,
                                              importacionSelected: !representante
                                            });
                                          }}
                                        >
                                          {submodelos?.map((item) => (
                                            <Option
                                              key={item.id}
                                              value={item.id}
                                            >
                                              {item.descripcion}
                                            </Option>
                                          ))}
                                        </Select>
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                  <Row
                                    gutter={[16, 0]}
                                    style={{ textAlign: 'start' }}
                                  >
                                    <Col xs={24} md={24}>
                                      <Form.Item noStyle shouldUpdate>
                                        {() => (
                                          <Form.Item
                                            label="Tipo de Uso"
                                            name="tipo_uso"
                                            rules={[
                                              {
                                                required: true,
                                                message:
                                                  'Debe indicar el tipo de uso del vehículo'
                                              }
                                            ]}
                                          >
                                            <div>
                                              {' '}
                                              <Radio.Group
                                                onChange={(e) => {
                                                  setTipoUso(e.target.value);
                                                  handleTipoUsoChange(e);
                                                }}
                                              >
                                                {TIPOS_USO_VEHICULO.map(
                                                  (item) => (
                                                    <Radio
                                                      key={item.codigo}
                                                      value={item.codigo}
                                                    >
                                                      {item.descripcion}
                                                    </Radio>
                                                  )
                                                )}
                                              </Radio.Group>
                                              {otrosHabilitados && (
                                                <div>
                                                  <br />
                                                  <p>Seleccione una opción:</p>
                                                  <Form.Item
                                                    name="tipo_uso_otros"
                                                    rules={[
                                                      {
                                                        required: true,
                                                        message:
                                                          'Debe indicar el tipo de uso del vehículo'
                                                      }
                                                    ]}
                                                  >
                                                    <Radio.Group
                                                      onChange={(e) => {
                                                        setTipoUso(
                                                          e.target.value
                                                        );
                                                      }}
                                                    >
                                                      {TIPOS_USO_VEHICULO_OTROS.map(
                                                        (item) => (
                                                          <Radio
                                                            key={item.codigo}
                                                            value={item.codigo}
                                                          >
                                                            {item.descripcion}
                                                          </Radio>
                                                        )
                                                      )}
                                                    </Radio.Group>
                                                  </Form.Item>
                                                </div>
                                              )}
                                            </div>
                                          </Form.Item>
                                        )}
                                      </Form.Item>
                                    </Col>

                                    <Col xs={24} md={12}>
                                      <Form.Item
                                        label="Importación directa (vía Chile, USA y Otros)"
                                        name="importacion"
                                        rules={[
                                          {
                                            required: true,
                                            message:
                                              'Debe indicar el tipo de Importación'
                                          }
                                        ]}
                                      >
                                        <Radio.Group
                                          onChange={(e) => {
                                            representanteChange(
                                              !e.target.value
                                            );

                                            mostrarVehiculoCero({
                                              value: submodelo,
                                              importacionSelected:
                                                e.target.value
                                            });
                                          }}
                                        >
                                          <Space direction="">
                                            <Radio value>Si</Radio>
                                            <Radio value={false}>No</Radio>
                                          </Space>
                                        </Radio.Group>
                                      </Form.Item>
                                    </Col>
                                    {anioActualizado && (
                                      <Col xs={24} md={12}>
                                        <Form.Item
                                          label="Vehículo 0 km"
                                          name="vehiculo0km"
                                          rules={[
                                            {
                                              required: true,
                                              message:
                                                'Debe indicar si el Vehículo pertenece a un 0 Km'
                                            }
                                          ]}
                                        >
                                          <Radio.Group
                                            onChange={(e) => {
                                              setCeroKm(e.target.value);
                                            }}
                                            // defaultValue={ceroKm}
                                          >
                                            <Space direction="">
                                              <Radio value>Si</Radio>
                                              <Radio value={false}>No</Radio>
                                            </Space>
                                          </Radio.Group>
                                        </Form.Item>
                                      </Col>
                                    )}
                                    {representante === false && (
                                      <Col xs={24} md={12}>
                                        <Form.Item
                                          label="Volante cambiado"
                                          name="volante_cambiado"
                                          rules={[
                                            {
                                              required: true,
                                              message:
                                                'Debe indicar si el Vehículo tiene el volante cambiado'
                                            }
                                          ]}
                                        >
                                          <Radio.Group
                                            onChange={(e) => {
                                              setVolanteCambiado(
                                                e.target.value
                                              );
                                            }}
                                          >
                                            <Space direction="">
                                              <Radio value>Si</Radio>
                                              <Radio value={false}>No</Radio>
                                            </Space>
                                          </Radio.Group>
                                        </Form.Item>
                                      </Col>
                                    )}
                                  </Row>
                                  <Row
                                    gutter={[16, 0]}
                                    style={{ textAlign: 'start' }}
                                  >
                                    <Col xs={24} md={12}>
                                      <Form.Item noStyle shouldUpdate>
                                        {() => {
                                          return (
                                            <Form.Item
                                              label="Combustible"
                                              name="combustible"
                                              rules={[
                                                {
                                                  required: true,
                                                  message:
                                                    'Debe indicar el combustible'
                                                }
                                              ]}
                                            >
                                              <Radio.Group
                                                disabled={
                                                  submodelo &&
                                                  submodelos &&
                                                  reconocerCombustible(
                                                    submodelo,
                                                    submodelos
                                                  )
                                                }
                                                onChange={(e) => {
                                                  setCombustible(
                                                    e.target.value
                                                  );
                                                }}
                                              >
                                                {TIPOS_COMBUSTIBLE.map(
                                                  (item) => (
                                                    <Radio
                                                      key={item.codigo}
                                                      value={item.codigo}
                                                    >
                                                      {item.descripcion}
                                                    </Radio>
                                                  )
                                                )}
                                              </Radio.Group>
                                            </Form.Item>
                                          );
                                        }}
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                  <br />
                                  <br />
                                  <Label>
                                    Monto: {formatoGs(monto, undefined, 'd')}
                                  </Label>
                                  <Slider
                                    step={1000000}
                                    value={monto}
                                    min={montoMin}
                                    max={montoMax}
                                    tooltip={{
                                      formatter: (value) =>
                                        formatoGs(value, undefined, 'd')
                                    }}
                                    // tooltipVisible={true}
                                    onChange={(value) => {
                                      setMonto(value);
                                      onMontoChange(value);
                                    }}
                                  />
                                  <br />
                                </>
                              </Card>
                            </>
                          </div>
                        )}

                      {/* Formulario de vigencia */}
                      {vigenciaSugeridaConfig && (
                        <div>
                          <div
                            style={{
                              display: current !== 0 && 'none'
                            }}
                          >
                            <div
                              style={{
                                textAlign: 'left'
                              }}
                            >
                              {/* Si algún plan tiene controles entonces se muestra el selector de dpto, distrito y/o ubicación */}
                              {/* Esto es debido a que la misma lista de planes se debe filtrar según el dpto, distrito y/o ubicación que elija */}
                              <div ref={ubicacionRef}>
                                {(tienePlanControlProductoZona() ||
                                  tieneAutorizacionPorTipo('ZONA')) &&
                                  statePassed.tipoCotizacion !== 'masiva' && (
                                    <ZonaForm {...zonaFormProps} />
                                  )}
                              </div>
                              {Number(producto) === 5 &&
                                statePassed.tipoCotizacion !== 'masiva' &&
                                tieneAutorizacionPorTipo('ACTIVIDAD') && (
                                  <div>
                                    <Subtitle>Datos de Actividad</Subtitle>
                                    <Card
                                      style={{
                                        textAlign: 'left',
                                        maxWidth,
                                        margin: 'auto',
                                        boxShadow: 'none'
                                      }}
                                    >
                                      <Row gutter={[16, 0]}>
                                        {tieneControlParaEstablecimiento() && (
                                          <Col xs={24} md={12} align="start">
                                            <Form.Item
                                              label="Tipo de Actividad"
                                              name="tipo_establecimiento"
                                              rules={[
                                                {
                                                  required: true,
                                                  message:
                                                    'Debe indicar el tipo de Actividad'
                                                }
                                              ]}
                                            >
                                              <Select
                                                mode="multiple"
                                                allowClear
                                                showSearch
                                                filterOption={filtrarListado}
                                                style={{
                                                  width: '100%'
                                                }}
                                                placeholder="Elegir tipo de Actividad"
                                                onChange={onChangeActividad}
                                                options={actividades}
                                                labelInValue
                                              />
                                            </Form.Item>
                                          </Col>
                                        )}
                                        {tieneControlParaRubro() && (
                                          <Col xs={24} md={12} align="start">
                                            <Form.Item
                                              label="Rubro"
                                              name="rubro"
                                              rules={[
                                                {
                                                  required: true,
                                                  message:
                                                    'Debe indicar el rubro'
                                                }
                                              ]}
                                            >
                                              <Select
                                                mode="multiple"
                                                allowClear
                                                showSearch
                                                filterOption={filtrarListado}
                                                onChange={onChangeRubro}
                                                style={{
                                                  width: '100%'
                                                }}
                                                maxTagCount="responsive"
                                                placeholder="Elegir tipo de Rubro"
                                                options={actividadDetalles}
                                                labelInValue
                                              />
                                            </Form.Item>
                                          </Col>
                                        )}
                                      </Row>
                                    </Card>
                                  </div>
                                )}
                              <div style={{ paddingTop: 20 }}>
                                {loadedPlanes && (
                                  <Subtitle>Parámetros</Subtitle>
                                )}
                                <Card>
                                  <SolicitudProvider>
                                    <VigenciaForm
                                      // type="secondary"
                                      hidden={!planes}
                                      vigenciaSugeridaConfig={
                                        vigenciaSugeridaConfig
                                      }
                                      setVigenciaByAseguradoraList={
                                        setVigenciaByAseguradoraList
                                      }
                                      vigenciaByAseguradoraList={
                                        vigenciaByAseguradoraList
                                      }
                                      setValidacionByAseguradoraList={
                                        setValidacionByAseguradoraList
                                      }
                                      withForm={form}
                                      style={{ textAlign: 'start' }}
                                      onInit={onInitVigenciaForm}
                                      // loading={loadingGeneral || loadingVigencias}
                                      // open={current === 0}
                                    />
                                  </SolicitudProvider>
                                  <div style={{ maxWidth, margin: 'auto' }}>
                                    <div
                                      style={{
                                        minHeight: 100
                                      }}
                                    >
                                      <div
                                        style={{
                                          textAlign: 'left'
                                        }}
                                      >
                                        <>
                                          <MonedaSelector
                                            multiple
                                            loading={loadingGeneral}
                                            value={monedaSelectedList?.map(
                                              (mon) => mon.codigo
                                            )}
                                            monedas={monedas}
                                            onChange={onChangeMoneda}
                                          />
                                          <br />
                                          <br />
                                          {(mostrarRadioButtonVentaTelefonica ||
                                            mostrarRadioButtonPresencial) &&
                                            statePassed.tipoCotizacion !==
                                              'masiva' && (
                                              <Form.Item
                                                label="Tipo de Venta"
                                                name="tipoDeVenta"
                                              >
                                                <Radio.Group
                                                  value={tipoVenta}
                                                  defaultValue="amedida"
                                                  onChange={(e) => {
                                                    setTipoVenta(
                                                      e.target.value
                                                    );
                                                  }}
                                                >
                                                  <Radio.Button value="amedida">
                                                    En línea
                                                  </Radio.Button>

                                                  {mostrarRadioButtonVentaTelefonica && (
                                                    <Radio.Button value="telefonica">
                                                      Telefónica
                                                    </Radio.Button>
                                                  )}
                                                  {mostrarRadioButtonPresencial && (
                                                    <Radio.Button value="presencial">
                                                      Presencial
                                                    </Radio.Button>
                                                  )}
                                                </Radio.Group>
                                              </Form.Item>
                                            )}
                                          {aplicaDescuentoRecargo() && (
                                            <Row gutter={[16, 0]}>
                                              <Col
                                                xs={24}
                                                md={24}
                                                align="start"
                                              >
                                                <Form.Item
                                                  label="¿Aplicar descuento o recargo?"
                                                  name="tieneDescuentoRecargo"
                                                  valuePropName="checked"
                                                >
                                                  <Switch
                                                    onChange={(value) => {
                                                      if (value === false) {
                                                        setReajuste(0);
                                                        onReajusteChange(0);
                                                        form.setFieldsValue({
                                                          descuento: undefined
                                                        });
                                                      }
                                                    }}
                                                  />
                                                </Form.Item>
                                              </Col>
                                              <Col
                                                xs={24}
                                                md={24}
                                                align="start"
                                              >
                                                <Form.Item shouldUpdate noStyle>
                                                  {({ getFieldValue }) => {
                                                    if (
                                                      getFieldValue(
                                                        'tieneDescuentoRecargo'
                                                      )
                                                    ) {
                                                      return (
                                                        <Form.Item
                                                          name="descuento"
                                                          normalize={(
                                                            value
                                                          ) => {
                                                            let newNumber =
                                                              value.number;
                                                            if (
                                                              Number(
                                                                value.number
                                                              ) > 100
                                                            ) {
                                                              newNumber = 100;
                                                            }
                                                            if (
                                                              Number(
                                                                value.number
                                                              ) < 0
                                                            ) {
                                                              newNumber = 0;
                                                            }
                                                            return {
                                                              ...value,
                                                              number: newNumber
                                                            };
                                                          }}
                                                          onChange={
                                                            onChangeDescuentoRecargo
                                                          }
                                                        >
                                                          <DescuentoRecargoInput />
                                                        </Form.Item>
                                                      );
                                                    }
                                                    return null;
                                                  }}
                                                </Form.Item>
                                              </Col>
                                            </Row>
                                          )}
                                        </>
                                      </div>
                                    </div>
                                  </div>
                                </Card>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <br />

                    {/* Selector de moneda, recargo y listado de planes */}
                    {current === 0 && !solicitado && loadedPlanes && (
                      <div
                        style={{
                          maxWidth,
                          margin: 'auto',
                          textAlign: 'center',
                          marginLeft: marginLeftPrincipal,
                          marginRight: marginRightPrincipal
                        }}
                      >
                        {visibleSectorPlanes && (
                          <Form.Item noStyle shouldUpdate>
                            {() => (
                              <div
                                style={{
                                  textAlign: 'start',
                                  maxWidth,
                                  margin: 'auto'
                                }}
                              >
                                {puedeMostrarPlanes ? (
                                  <div
                                    style={{
                                      width: '100%',
                                      display:
                                        screens && screens.md === false
                                          ? ''
                                          : 'inline-block'
                                    }}
                                  >
                                    <div
                                      style={{
                                        textAlign: 'left'
                                      }}
                                    >
                                      <Subtitle>Selección de planes</Subtitle>
                                      <Divider />
                                      {sucursales && sucursales.length > 1 && (
                                        <SucursalSelector />
                                      )}
                                    </div>
                                    <GroupPlanSelectorMultiple
                                      selected={{
                                        estandar: selectedIndexsEst,
                                        especifico: selectedIndexsEsp
                                      }}
                                      cotizaciones={getFilteredCotizaciones()}
                                      onChange={onChangePlanSelector}
                                      opcionesDePago={{
                                        numeroCuotas: vigencia?.cantidad_pagos
                                      }}
                                      monedaSelectedList={monedaSelectedList}
                                      {...{
                                        validacionByAseguradoraList,
                                        mostrarValidaciones
                                      }}
                                      subcoberturasParaExcluir={
                                        subcoberturasParaExcluir
                                      }
                                      controlFranquicias={controlFranquicias}
                                      alertaParaEjecutivo
                                      comisionAseguradoraList={
                                        comisionesAseguradora
                                      }
                                      comisionesAEPList={comisionesAEP}
                                    />
                                  </div>
                                ) : (
                                  <div
                                    style={{
                                      textAlign: 'center',
                                      maxWidth,
                                      margin: 'auto'
                                    }}
                                  >
                                    <span>
                                      Debe completar el formulario para ver las
                                      opciones disponibles
                                    </span>
                                  </div>
                                )}
                              </div>
                            )}
                          </Form.Item>
                        )}
                      </div>
                    )}
                  </Spin>

                  <div
                    style={{
                      maxWidth,
                      textAlign: 'start',
                      marginLeft: marginLeftPrincipal,
                      marginRight: marginRightPrincipal
                    }}
                  >
                    {current === 1 && !solicitado && (
                      <>
                        {aseguradoras.map((asegu) => {
                          if (!existePlan(asegu)) {
                            return null;
                          }
                          const selectedPlanesEstAseg = selectedPlanesEst.filter(
                            (item) =>
                              item.aseguradoraProducto.id_aseguradora ===
                              asegu.id
                          );
                          const selectedPlanesEspAseg = selectedPlanesEsp.filter(
                            (item) =>
                              item.aseguradoraProducto.id_aseguradora ===
                              asegu.id
                          );
                          const unaComision = verificarComisionUnica([
                            ...selectedPlanesEst,
                            ...selectedPlanesEsp
                          ]);
                          return (
                            <Fragment key={asegu.id}>
                              {(selectedPlanesEstAseg.length > 0 ||
                                selectedPlanesEspAseg.length > 0) && (
                                <LogoYTexto
                                  logo={`/images/aseguradoras/${asegu.codigo}.png`}
                                  texto={asegu.nombre}
                                />
                              )}
                              <br />
                              {selectedPlanesEstAseg.length > 0 && (
                                <div
                                  style={{
                                    width: '100%',
                                    paddingBottom: 20,
                                    display:
                                      screens && screens.md === false
                                        ? ''
                                        : 'inline-block',
                                    textAlign: 'left'
                                  }}
                                >
                                  <SubSubtitleStart level={4}>
                                    Planes Estándar
                                  </SubSubtitleStart>
                                  {(() => {
                                    return !unaComision ? (
                                      <>
                                        {comisionesAseguradora.map(
                                          (comision) =>
                                            tieneComision(
                                              comision,
                                              selectedPlanesEstAseg
                                            ) && (
                                              <>
                                                <Collapse expandIconPosition="end">
                                                  <Panel
                                                    header={
                                                      <PanelHeader
                                                        empresa=""
                                                        comision={comision}
                                                      />
                                                    }
                                                    key={`planEstandar${comision.id}`}
                                                    className="collapse-centered"
                                                  >
                                                    {(() => {
                                                      return (
                                                        <>
                                                          {monedaSelectedList.map(
                                                            (mon) => {
                                                              return (
                                                                <div
                                                                  key={mon.id}
                                                                  style={{
                                                                    display:
                                                                      'inline-flex'
                                                                  }}
                                                                >
                                                                  <PlanEditor
                                                                    puedeEditar={
                                                                      false
                                                                    }
                                                                    planLoading={
                                                                      planLoading
                                                                    }
                                                                    planes={selectedPlanesEstAseg.filter(
                                                                      (item) =>
                                                                        item.id_moneda ===
                                                                          mon.id &&
                                                                        item.id_comision_aseguradora ===
                                                                          comision.id
                                                                    )}
                                                                    comisionAseguradora={
                                                                      comision
                                                                    }
                                                                    onEditPlanCoberturaMinMaxItem={(
                                                                      data,
                                                                      _,
                                                                      columna
                                                                    ) =>
                                                                      onEditPlanCoberturaMinMaxItem(
                                                                        data,
                                                                        null,
                                                                        columna
                                                                      )
                                                                    }
                                                                    onChangePlan={(
                                                                      event,
                                                                      fila
                                                                    ) => {
                                                                      const nuevoValor =
                                                                        event &&
                                                                        event.target
                                                                          ? event
                                                                              .target
                                                                              .value
                                                                          : event;
                                                                      updatePlanes(
                                                                        nuevoValor,
                                                                        fila,
                                                                        'est',
                                                                        mon
                                                                      );
                                                                      // Currency maneja value y el Input maneja event
                                                                    }}
                                                                    onChangeCobertura={() => {
                                                                      // onChangeCoberturaEspecifico(event, fila, item.id)
                                                                    }}
                                                                    onDeleteCobertura={(
                                                                      idCobertura
                                                                    ) =>
                                                                      onDeleteCobertura(
                                                                        idCobertura,
                                                                        'est',
                                                                        asegu.id,
                                                                        mon
                                                                      )
                                                                    }
                                                                    moneda={mon}
                                                                    opcionesDePago={{
                                                                      numeroCuotas:
                                                                        vigencia?.cantidad_pagos
                                                                    }}
                                                                    amedida
                                                                    subcoberturasParaExcluir={
                                                                      subcoberturasParaExcluir
                                                                    }
                                                                    controlFranquicias={
                                                                      controlFranquicias
                                                                    }
                                                                    onEditPlanSubcoberturas={(
                                                                      idPlan,
                                                                      idCobertura,
                                                                      newSubcobertura
                                                                    ) => {
                                                                      onChangePlanSubcobertura(
                                                                        'est',
                                                                        asegu.id,
                                                                        mon,
                                                                        idPlan,
                                                                        idCobertura,
                                                                        newSubcobertura
                                                                      );
                                                                    }}
                                                                  />
                                                                  <br />
                                                                </div>
                                                              );
                                                            }
                                                          )}
                                                        </>
                                                      );
                                                    })()}
                                                  </Panel>
                                                </Collapse>
                                                <br />
                                              </>
                                            )
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {monedaSelectedList.map((mon) => {
                                          return (
                                            <div
                                              key={mon.id}
                                              style={{
                                                display: 'inline-flex'
                                              }}
                                            >
                                              <PlanEditor
                                                puedeEditar={false}
                                                planLoading={planLoading}
                                                planes={selectedPlanesEstAseg.filter(
                                                  (item) =>
                                                    item.id_moneda === mon.id
                                                )}
                                                comisionAseguradora={
                                                  selectedPlanesEstAseg[0]
                                                    .comisionAseguradora
                                                }
                                                onEditPlanCoberturaMinMaxItem={(
                                                  data,
                                                  _,
                                                  columna
                                                ) =>
                                                  onEditPlanCoberturaMinMaxItem(
                                                    data,
                                                    null,
                                                    columna
                                                  )
                                                }
                                                onChangePlan={(event, fila) => {
                                                  const nuevoValor =
                                                    event && event.target
                                                      ? event.target.value
                                                      : event;
                                                  updatePlanes(
                                                    nuevoValor,
                                                    fila,
                                                    'est',
                                                    mon
                                                  );
                                                  // Currency maneja value y el Input maneja event
                                                }}
                                                onChangeCobertura={() => {
                                                  // onChangeCoberturaEspecifico(event, fila, item.id)
                                                }}
                                                onDeleteCobertura={(
                                                  idCobertura
                                                ) =>
                                                  onDeleteCobertura(
                                                    idCobertura,
                                                    'est',
                                                    asegu.id,
                                                    mon
                                                  )
                                                }
                                                moneda={mon}
                                                opcionesDePago={{
                                                  numeroCuotas:
                                                    vigencia?.cantidad_pagos
                                                }}
                                                amedida
                                                subcoberturasParaExcluir={
                                                  subcoberturasParaExcluir
                                                }
                                                controlFranquicias={
                                                  controlFranquicias
                                                }
                                                onEditPlanSubcoberturas={(
                                                  idPlan,
                                                  idCobertura,
                                                  newSubcobertura
                                                ) => {
                                                  onChangePlanSubcobertura(
                                                    'est',
                                                    asegu.id,
                                                    mon,
                                                    idPlan,
                                                    idCobertura,
                                                    newSubcobertura
                                                  );
                                                }}
                                              />
                                              <br />
                                            </div>
                                          );
                                        })}
                                      </>
                                    );
                                  })()}
                                </div>
                              )}
                              <br />
                              {selectedPlanesEspAseg.length > 0 && (
                                <div
                                  style={{
                                    width: '100%',
                                    paddingBottom: 20,
                                    display:
                                      screens && screens.md === false
                                        ? ''
                                        : 'inline-block',
                                    textAlign: 'left'
                                  }}
                                >
                                  <Space>
                                    <SubSubtitleStart level={4}>
                                      Planes Específicos
                                    </SubSubtitleStart>
                                  </Space>
                                  <br />
                                  {(() => {
                                    return !unaComision ? (
                                      <>
                                        {comisionesAseguradora.map(
                                          (comision) =>
                                            tieneComision(
                                              comision,
                                              selectedPlanesEspAseg
                                            ) && (
                                              <>
                                                <Collapse expandIconPosition="end">
                                                  <Panel
                                                    header={
                                                      <PanelHeader
                                                        empresa=""
                                                        comision={comision}
                                                      />
                                                    }
                                                    key={`planEspecifico${comision.id}`}
                                                    className="collapse-centered"
                                                  >
                                                    {(() => {
                                                      return (
                                                        <>
                                                          {monedaSelectedList.map(
                                                            (mon) => {
                                                              return (
                                                                <div
                                                                  key={mon.id}
                                                                  style={{
                                                                    display:
                                                                      'inline-flex'
                                                                  }}
                                                                >
                                                                  <PlanEditor
                                                                    puedeEditar={
                                                                      false
                                                                    }
                                                                    producto={
                                                                      producto
                                                                    }
                                                                    planLoading={
                                                                      planLoading
                                                                    }
                                                                    planes={filterSucursalPlan(
                                                                      selectedPlanesEspAseg.filter(
                                                                        (
                                                                          item
                                                                        ) =>
                                                                          item.id_moneda ===
                                                                            mon.id &&
                                                                          item.id_comision_aseguradora ===
                                                                            comision.id
                                                                      )
                                                                    )}
                                                                    moneda={mon}
                                                                    comisionAseguradora={
                                                                      comision
                                                                    }
                                                                    onEditPlanCoberturaMinMaxItem={(
                                                                      data,
                                                                      _,
                                                                      columna
                                                                    ) =>
                                                                      onEditPlanCoberturaMinMaxItem(
                                                                        data,
                                                                        null,
                                                                        columna
                                                                      )
                                                                    }
                                                                    onChangePlan={(
                                                                      event,
                                                                      fila
                                                                    ) => {
                                                                      const nuevoValor =
                                                                        event &&
                                                                        event.target
                                                                          ? event
                                                                              .target
                                                                              .value
                                                                          : event;
                                                                      updatePlanes(
                                                                        nuevoValor,
                                                                        fila,
                                                                        'esp',
                                                                        mon
                                                                      );
                                                                      // Currency maneja value y el Input maneja event
                                                                    }}
                                                                    canChangeTitle={filterSucursalPlan(
                                                                      selectedPlanesEspAseg.filter(
                                                                        (
                                                                          item
                                                                        ) =>
                                                                          item.id_moneda ===
                                                                            mon.id &&
                                                                          item.id <
                                                                            0
                                                                      )
                                                                    ).map(
                                                                      (item) =>
                                                                        item.id
                                                                    )}
                                                                    onChangePlanTitle={
                                                                      onChangePlanTitleEspecifico
                                                                    }
                                                                    onChangeCobertura={() => {
                                                                      // onChangeCoberturaEspecifico(event, fila, item.id)
                                                                    }}
                                                                    onDeleteCobertura={(
                                                                      idCobertura
                                                                    ) =>
                                                                      onDeleteCobertura(
                                                                        idCobertura,
                                                                        'esp',
                                                                        asegu.id,
                                                                        mon
                                                                      )
                                                                    }
                                                                    opcionesDePago={{
                                                                      numeroCuotas:
                                                                        vigencia?.cantidad_pagos
                                                                    }}
                                                                    amedida
                                                                    subcoberturasParaExcluir={
                                                                      subcoberturasParaExcluir
                                                                    }
                                                                    controlFranquicias={
                                                                      controlFranquicias
                                                                    }
                                                                    onEditPlanSubcoberturas={(
                                                                      idPlan,
                                                                      idCobertura,
                                                                      newSubcobertura
                                                                    ) =>
                                                                      onChangePlanSubcobertura(
                                                                        'esp',
                                                                        asegu.id,
                                                                        mon,
                                                                        idPlan,
                                                                        idCobertura,
                                                                        newSubcobertura
                                                                      )
                                                                    }
                                                                  />
                                                                  <br />
                                                                  <br />
                                                                </div>
                                                              );
                                                            }
                                                          )}
                                                        </>
                                                      );
                                                    })()}
                                                  </Panel>
                                                </Collapse>
                                                <br />
                                              </>
                                            )
                                        )}
                                      </>
                                    ) : (
                                      (() => {
                                        return (
                                          <>
                                            {monedaSelectedList.map((mon) => {
                                              return (
                                                <div
                                                  key={mon.id}
                                                  style={{
                                                    display: 'inline-flex'
                                                  }}
                                                >
                                                  <PlanEditor
                                                    puedeEditar={false}
                                                    producto={producto}
                                                    planLoading={planLoading}
                                                    planes={filterSucursalPlan(
                                                      selectedPlanesEspAseg.filter(
                                                        (item) =>
                                                          item.id_moneda ===
                                                          mon.id
                                                      )
                                                    )}
                                                    moneda={mon}
                                                    comisionAseguradora={
                                                      selectedPlanesEspAseg[0]
                                                        .comisionAseguradora
                                                    }
                                                    onEditPlanCoberturaMinMaxItem={(
                                                      data,
                                                      _,
                                                      columna
                                                    ) =>
                                                      onEditPlanCoberturaMinMaxItem(
                                                        data,
                                                        null,
                                                        columna
                                                      )
                                                    }
                                                    onChangePlan={(
                                                      event,
                                                      fila
                                                    ) => {
                                                      const nuevoValor =
                                                        event && event.target
                                                          ? event.target.value
                                                          : event;
                                                      updatePlanes(
                                                        nuevoValor,
                                                        fila,
                                                        'esp',
                                                        mon
                                                      );
                                                      // Currency maneja value y el Input maneja event
                                                    }}
                                                    canChangeTitle={filterSucursalPlan(
                                                      selectedPlanesEspAseg.filter(
                                                        (item) =>
                                                          item.id_moneda ===
                                                            mon.id &&
                                                          item.id < 0
                                                      )
                                                    ).map((item) => item.id)}
                                                    onChangePlanTitle={
                                                      onChangePlanTitleEspecifico
                                                    }
                                                    onChangeCobertura={() => {
                                                      // onChangeCoberturaEspecifico(event, fila, item.id)
                                                    }}
                                                    onDeleteCobertura={(
                                                      idCobertura
                                                    ) =>
                                                      onDeleteCobertura(
                                                        idCobertura,
                                                        'esp',
                                                        asegu.id,
                                                        mon
                                                      )
                                                    }
                                                    opcionesDePago={{
                                                      numeroCuotas:
                                                        vigencia?.cantidad_pagos
                                                    }}
                                                    amedida
                                                    subcoberturasParaExcluir={
                                                      subcoberturasParaExcluir
                                                    }
                                                    controlFranquicias={
                                                      controlFranquicias
                                                    }
                                                    onEditPlanSubcoberturas={(
                                                      idPlan,
                                                      idCobertura,
                                                      newSubcobertura
                                                    ) =>
                                                      onChangePlanSubcobertura(
                                                        'esp',
                                                        asegu.id,
                                                        mon,
                                                        idPlan,
                                                        idCobertura,
                                                        newSubcobertura
                                                      )
                                                    }
                                                  />
                                                  <br />
                                                  <br />
                                                </div>
                                              );
                                            })}
                                          </>
                                        );
                                      })()
                                    );
                                  })()}
                                </div>
                              )}
                            </Fragment>
                          );
                        })}
                      </>
                    )}
                  </div>
                  {current === 2 && !solicitado && (
                    <>
                      <div
                        style={{
                          maxWidth,
                          margin: 'auto',
                          textAlign: 'start',
                          fontSize: 18,
                          marginLeft: marginLeftPrincipal,
                          marginRight: marginRightPrincipal
                        }}
                      >
                        <p>
                          Vista previa de cotización de seguros de{' '}
                          <strong>{productoActual}</strong>. A continuación el
                          detalle de los planes cotizados:
                        </p>
                      </div>
                      <div
                        style={{
                          maxWidth,
                          textAlign: 'start',
                          margin: 'auto',
                          marginLeft: marginLeftPrincipal,
                          marginRight: marginRightPrincipal
                        }}
                      >
                        <div
                          style={{
                            display:
                              screens && screens.md === false
                                ? ''
                                : 'inline-block',
                            textAlign: 'start'
                          }}
                        >
                          <>
                            {aseguradoras.map((asegu) => {
                              if (!existePlan(asegu)) {
                                return null;
                              }

                              const selectedPlanesEstAseg = selectedPlanesEst
                                .filter(
                                  (item) =>
                                    item.aseguradoraProducto.id_aseguradora ===
                                    asegu.id
                                )
                                .sort((a, b) => a.orden - b.orden);
                              const selectedPlanesEspAseg = selectedPlanesEsp
                                .filter(
                                  (item) =>
                                    item.aseguradoraProducto.id_aseguradora ===
                                    asegu.id
                                )
                                .sort((a, b) => a.orden - b.orden);
                              return (
                                <Fragment key={asegu.id}>
                                  {(selectedPlanesEstAseg.length > 0 ||
                                    selectedPlanesEspAseg.length > 0) && (
                                    <LogoYTexto
                                      logo={`/images/aseguradoras/${asegu.codigo}.png`}
                                      texto={asegu.nombre}
                                    />
                                  )}
                                  {selectedPlanesEstAseg.length > 0 && (
                                    <div>
                                      <div
                                        style={{
                                          paddingBottom: 20,
                                          display:
                                            screens && screens.md === false
                                              ? ''
                                              : 'inline-block',
                                          textAlign: 'start'
                                        }}
                                      >
                                        {selectedPlanesEstAseg.length ? (
                                          <>
                                            <SubSubtitleStart level={4}>
                                              Planes Estándar
                                            </SubSubtitleStart>
                                            <div>
                                              {(() => {
                                                return (
                                                  <>
                                                    {monedaSelectedList.map(
                                                      (moneda) => {
                                                        return (
                                                          <Fragment
                                                            key={moneda.id}
                                                          >
                                                            <PlanSelector
                                                              planes={selectedPlanesEstAseg.filter(
                                                                (item) =>
                                                                  item.id_moneda ===
                                                                  moneda.id
                                                              )}
                                                              hover={false}
                                                              mostrarTipo
                                                              moneda={moneda}
                                                              opcionesDePago={{
                                                                numeroCuotas:
                                                                  vigencia?.cantidad_pagos
                                                              }}
                                                              subcoberturasParaExcluir={
                                                                subcoberturasParaExcluir
                                                              }
                                                              controlFranquicias={
                                                                controlFranquicias
                                                              }
                                                              infoMoneda
                                                              readonly
                                                            />
                                                            <br />
                                                          </Fragment>
                                                        );
                                                      }
                                                    )}
                                                  </>
                                                );
                                              })()}
                                            </div>
                                          </>
                                        ) : null}
                                      </div>
                                    </div>
                                  )}
                                  {selectedPlanesEspAseg.length > 0 && (
                                    <div>
                                      <div
                                        style={{
                                          display:
                                            screens && screens.md === false
                                              ? ''
                                              : 'inline-block',
                                          textAlign: 'start'
                                        }}
                                      >
                                        {selectedPlanesEspAseg.length ? (
                                          <>
                                            <SubSubtitleStart level={4}>
                                              Planes Específicos
                                            </SubSubtitleStart>
                                            <div>
                                              {(() => {
                                                return (
                                                  (subcoberturasParaExcluir ||
                                                    controlFranquicias) && (
                                                    <>
                                                      {monedaSelectedList.map(
                                                        (moneda) => {
                                                          return (
                                                            <Fragment
                                                              key={moneda.id}
                                                            >
                                                              <PlanSelector
                                                                planes={selectedPlanesEspAseg.filter(
                                                                  (item) =>
                                                                    item.id_moneda ===
                                                                    moneda.id
                                                                )}
                                                                hover={false}
                                                                mostrarTipo
                                                                moneda={moneda}
                                                                opcionesDePago={{
                                                                  numeroCuotas:
                                                                    vigencia?.cantidad_pagos
                                                                }}
                                                                subcoberturasParaExcluir={
                                                                  subcoberturasParaExcluir
                                                                }
                                                                controlFranquicias={
                                                                  controlFranquicias
                                                                }
                                                                infoMoneda
                                                                readonly
                                                              />
                                                            </Fragment>
                                                          );
                                                        }
                                                      )}
                                                    </>
                                                  )
                                                );
                                              })()}
                                            </div>
                                            <br />
                                          </>
                                        ) : null}
                                      </div>
                                    </div>
                                  )}
                                </Fragment>
                              );
                            })}
                          </>
                        </div>
                      </div>
                      <div>
                        {' '}
                        {statePassed.tipoCotizacion === 'masiva' && (
                          <>
                            <UploadCotizacionMasivaForm
                              onFinish={enviarCotizacion}
                              loading={loading}
                              solicitado={solicitado}
                              onValuesChange={(_, values) =>
                                actualizarTextoWhatsApp(values)
                              }
                              amedida
                              goBack={goBack}
                              setCotizacionMasivaPersonaList={
                                setCotizacionMasivaPersonaList
                              }
                              setLoading={setLoading}
                              setEnvioSms={setEnvioSms}
                              setEnvioCorreo={setEnvioCorreo}
                              setTextoSms={setTextoSms}
                              textoSms={textoSms}
                              envioSms={envioSms}
                              envioCorreo={envioCorreo}
                              setTextoBodyMail={setTextoBodyMail}
                              textoBodyMail={textoBodyMail}
                              asuntoMail={asuntoMail}
                              setAsuntoMail={setAsuntoMail}
                              campañaName={campañaName}
                              setCampañaName={setCampañaName}
                              empresaTieneSms={empresa.tiene_sms}
                            />
                          </>
                        )}
                      </div>
                      <br />
                    </>
                  )}
                </Form>
              </div>
            )}
            {current === 2 &&
              !solicitado &&
              statePassed.tipoCotizacion !== 'masiva' && (
                <div
                  style={{
                    maxWidth,
                    textAlign: 'start',
                    margin: 'auto',
                    marginLeft: marginLeftPrincipal,
                    marginRight: marginRightPrincipal
                  }}
                >
                  <ContactForm
                    onFinish={enviarCotizacion}
                    loading={loading}
                    solicitado={solicitado}
                    onValuesChange={(_, values) =>
                      actualizarTextoWhatsApp(values)
                    }
                    amedida
                    tipoDeVenta={tipoVenta}
                    goBack={goBack}
                    setMail={setMail}
                    empresaTieneSms={empresa.tiene_sms}
                  />
                </div>
              )}
            <div className="steps-action">
              {current === 1 && (
                <Button
                  style={{ margin: 10 }}
                  onClick={() => {
                    setCurrent(current - 1);
                  }}
                >
                  Anterior
                </Button>
              )}
              {current < 2 && current !== steps.length - 1 && (
                <Button
                  type="primary"
                  style={{ margin: 10 }}
                  disabled={loadingGeneral || !loadedPlanes || debouncingPlanes}
                  onClick={handleNextStepClick}
                >
                  Siguiente
                </Button>
              )}
              {solicitado &&
                !tieneAutorizaciones &&
                tokenGenerado &&
                empresa.tiene_sms && (
                  <Result
                    status="success"
                    title="¡La cotización ha sido enviada!"
                    subTitle={
                      mail
                        ? 'Recibirá un e-mail y SMS para continuar con su solicitud'
                        : 'Recibirá un mensaje de texto para continuar con su solicitud'
                    }
                    extra={[
                      <Button
                        type="primary"
                        key="nueva"
                        onClick={() => window.location.reload()}
                        style={{
                          marginLeft: 4,
                          marginRight: 4,
                          marginBottom: 8
                        }}
                      >
                        Cargar nueva
                      </Button>,
                      statePassed.tipoCotizacion !== 'masiva' && (
                        <Button
                          type="primary"
                          ghost
                          key="continuar"
                          onClick={() =>
                            handleOpenUrl(`/solicitar/${tokenGenerado}`)
                          }
                          style={{
                            marginLeft: 4,
                            marginRight: 4,
                            marginBottom: 8
                          }}
                        >
                          Continuar con la solicitud
                        </Button>
                      )
                    ]}
                  />
                )}
              {solicitado && tieneAutorizaciones && (
                <Result
                  title="Cotización sujeta a autorización del área técnica"
                  subTitle="La cotización solicitada está sujeta a autorización. Una vez aprobada, le enviaremos una notificación."
                  extra={[
                    <Button
                      type="primary"
                      key="nueva"
                      onClick={() => window.location.reload()}
                    >
                      Cargar nueva
                    </Button>
                  ]}
                />
              )}
            </div>
          </>
        )}
        <PlanConfig
          open={openPlanEditor}
          onCancel={() => setOpenPlanEditor(false)}
          onOk={onPlanEditFinish}
          plan={planEdit}
          disabledProductoCerrado
        />
        {(() => {
          return (
            <>
              {monedaSelectedList.map((moneda) => {
                return (
                  <Fragment key={moneda.id}>
                    <PlanCoberturaItemMinMaxConfig
                      open={openPlanCoberturaItemMinMaxEditor}
                      onCancel={() =>
                        setOpenPlanCoberturaItemMinMaxEditor(false)
                      }
                      onOk={onEditPlanCoberturaItemMinMaxFinish}
                      model={planCoberturaItemEdit}
                      moneda={(monedas, moneda)}
                    />
                  </Fragment>
                );
              })}
            </>
          );
        })()}
      </Card>
    </ResponsiveContainer>
  );
};
export default CotizacionAMedida;
